import React, { useCallback, useState, useEffect, useRef, createRef, useMemo } from 'react';
import {
   useColorModeValue,
   Card,
   Grid,
   GridItem,
   Button,
   CardBody,
   CardHeader,
   Heading,
   useToast,
   CardFooter,
   Flex,
   useDisclosure,
   Box,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   TableContainer,
   IconButton,
   Image,
   Text,
   Badge,
   Icon,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalHeader,
   ModalContent,
   ModalOverlay,
} from '@chakra-ui/react';
import { FaHistory } from 'react-icons/fa';
import { FaCircleInfo } from 'react-icons/fa6';
import { getSerialWiseHistory } from '../../../../../redux/actions/salesLineDetail';
import { getAdjustedDocs } from '../../../../../redux/actions/salesInvoice';
import * as Yup from 'yup';
import moment from 'moment';
import Swal from 'sweetalert2';
import _ from 'lodash';

// UI
// import LineItem from '../../../sales/Pages/SalesInvoiceMaster/LineItem';
import LineItem from 'components/LineItem';
import BillTerm from '../../../sales/Pages/SalesInvoiceMaster/BillTerm';
import TaxableAmount from '../../../sales/Pages/SalesInvoiceMaster/TaxableAmount';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import InputField from 'components/ui/InputField';
import SerialNumberModal from '../../../sales/Pages/SalesInvoiceMaster/SerialNumberModal';
import SerialNoBlockModal from './SerialNoBlockModal';
import TextareaField from 'components/ui/TextareaField';
import PrintFormat from 'components/PrintFormate/PrintFormat';
import AccountSelect from 'components/AccountSelect/AccountSelect';

import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// contexts
import { useUser, useGlobal, useAccount, useDaybook, useItem } from '../../../../../contexts';

// hooks
import useCalculateTaxAmount from 'hooks/useSalesTaxAmount';
import usePurchaseReturnLastDaybook from 'hooks/usePurchaseReturnLastDaybook';

// Actions
import { getStock } from '../../../../../redux/actions/salesLineDetail';
import { getAccount } from '../../../../../redux/actions/account';
import { getPaymentDaybook, getDaybook, updateDaybook } from '../../../../../redux/actions/daybook';
import { getItem, getItemForMaster } from '../../../../../redux/actions/item';
import { getMainAndSubHsn } from '../../../../../redux/actions/mainAndSubHsn';
import { getWarehouse } from '../../../../../redux/actions/warehouse';
import { getGLGroupsAllDropdown } from '../../../../../redux/actions/glGroup';
import {
   addPurchaseReturnInvoice,
   updatePurchaseReturnInvoice,
   getPurchaseReturnInvoice,
   getPurchaseReturnInvoices,
   deletePurchaseReturnLineItem,
   emptyPurchaseReturn,
   getPrevAndNext,
   checkDocNo,
   getLastPurchaseReturnDaybook,
} from '../../../../../redux/actions/purchaseReturnInvoice';
import { getBillTerm } from '../../../../../redux/actions/billTerm';
import { getSetupFormat, setupFormatCustomQuery } from '../../../../../redux/actions/setupFormat';
import { getUsers } from '../../../../../redux/actions/user';
import { getFinancialYears } from '../../../../../redux/actions/dashboard';

// utils
import {
   removeDuplicates,
   getDefaultId,
   getAccountAddress,
   getGstTaxType,
   getGstSubTaxType,
   handlePrintClick,
   injectDataIntoHtml,
   getFirstErrorMessage,
   formatAmount,
   getUniqueByStock,
   getCommonItemRate,
   getGstRate
} from 'utils/util';
import { SupplyTypes } from 'utils/dropdownEnum';

// icons
import { FaTrash } from 'react-icons/fa';

// image
import phone from 'assets/img/nfts/phone.svg';
import Email from 'assets/img/nfts/email.svg';
import map from 'assets/img/nfts/map.svg';
import panno from 'assets/img/nfts/panno.svg';
import gstno from 'assets/img/nfts/gstno.svg';
import Brokername from 'assets/img/nfts/Brokername.svg';
import Balance from 'assets/img/nfts/Balance.svg';
import loaderAnimation from 'assets/img/auth/loding.gif';
import back from 'assets/img/nfts/back.svg';

import DeleteDialog from '../../../masters/components/DeleteDialog';

import { USER_TYPES } from 'constants';

const validationSchema = Yup.object().shape({
   header: Yup.object().shape({
      daybookId: Yup.number()
         .typeError('Daybook is required')
         .required('Daybook is required')
         .positive('Invalid daybook selected'),

      docno: Yup.string().required('Document number is required').trim(),
      partyNo: Yup.string().required('Party number is required').trim(),
      partyDate: Yup.date().required('Party date is required'),
      transactionAt: Yup.date()
         .required('Transaction date is required'),

      accountId: Yup.number()
         .typeError('Account is required')
         .required('Account is required')
         .positive('Invalid account selected'),

      basicAmount: Yup.number().required('Basic amount is required').min(0, 'Basic amount cannot be negative'),
      // .test(
      //    'is-decimal',
      //    'Amount cannot have more than 2 decimal places',
      //    (value) => !value || Number.isInteger(value * 100),
      // ),
      netAmount: Yup.number().required('Net amount is required'),
   }),

   lineItem: Yup.array()
      .required('Line items are required')
      .min(1, 'At least one line item is required')
      .of(
         Yup.object().shape({
            itemId: Yup.number()
               .typeError('Item is required')
               .required('Item is required')
               .positive('Invalid item selected'),

            itemRate: Yup.number().required('Item rate is required').min(0, 'Item rate cannot be negative'),
            // .test(
            //    'is-decimal',
            //    'Rate cannot have more than 2 decimal places',
            //    (value) => !value || Number.isInteger(value * 100),
            // ),

            qty1: Yup.number().required('Quantity is required').min(0, 'Quantity cannot be negative'),

            qty2: Yup.number().default(0).min(0, 'Quantity cannot be negative'),

            qty3: Yup.number().default(0).min(0, 'Quantity cannot be negative'),

            amount: Yup.number().required('Amount is required').min(0, 'Amount cannot be negative'),

            ratePer: Yup.number().min(0, 'Rate per cannot be negative'),

            uomNoForRate: Yup.number()
               .integer('UOM number must be a whole number')
               .min(0, 'UOM number cannot be negative'),

            lineNumber: Yup.number()
               .required('Line number is required')
               .positive('Line number must be positive')
               .integer('Line number must be a whole number'),
         }),
      ),
});

const invoiceType = 'purchaseReturn';
const PurchaseReturnInvoiceForm = () => {
   const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();
   const { isOpen: isOpenSerialhistory, onOpen: onOpenSerialhistory, onClose: onCloseSerialhistory } = useDisclosure();
   const { isOpen: isOpenAdjustedDocs, onOpen: onOpenAdjustedDocs, onClose: onCloseAdjustedDocs } = useDisclosure();
   const {
      isOpen: isOpenPrintFormatModal,
      onOpen: onOpenPrintFormatModal,
      onClose: onClosePrintFormatModal,
   } = useDisclosure();
   const {
      isOpen: isOpenSerialBlockModal,
      onOpen: onOpenSerialBlockModal,
      onClose: onCloseSerialBlockModal,
   } = useDisclosure();
   const [pendingBlockSerials, setPendingBlockSerials] = React.useState([]);
   const [postBlockAction, setPostBlockAction] = React.useState(null);
   const { lastPurchaseReturnDaybook, setSelectedDaybookId: setDaybookId } = usePurchaseReturnLastDaybook();
   const { user } = useUser();
   const { companyList, company } = useGlobal();
   // const { items: itemData } = useItem();
   const { accounts: accountData, incomeAccounts } = useAccount();
   const { purchaseReturnDaybooks: daybookData } = useDaybook();

   // all Selector
   // const itemData = useSelector((state) => state.item?.list);
   // const daybookData = useSelector((state) => state.daybook?.allDaybooks || []);
   // const accountData = useSelector((state) => state?.account?.list);
   const billTermData = useSelector((state) => state.billTerm?.list);
   const salesInvoice = useSelector((state) => state.purchaseReturnInvoice?.single);
   const stocks = useSelector((state) => state?.salesLineDetail?.stocks);
   const warehouse = useSelector((state) => state?.warehouse?.list);
   const warehouseList = useSelector((state) => state.warehouse.list);
   // const companyData = useSelector((state) => state.company.single);
   const companyData = company;
   const glGroup = useSelector((state) => state.glGroup?.ledger || []);
   const targetGlGroup = glGroup.find((group) => group.code === 'E');
   const prints = useSelector((state) => state.setupPrint.list);
   const serialWiseHistory = useSelector((state) => state?.salesLineDetail?.serialhistory);
   const adjustedDocs = useSelector((state) => state?.sales?.adjusted);
   const salesManList = useSelector((state) => state.users.users || []);
   const financialYears = useSelector((state) => state?.dashboard?.financialYears);
   const [data, setData] = useState([]);
   const [itemData, setItemData] = useState([]);
   const [selectedItem, setSelectedItem] = useState(null);
   const [originalPrefix, setOriginalPrefix] = useState('');
   const [originalPostFix, setOriginalPostFix] = useState('');
   const { userGlobalSettingsData } = useGlobal();
   const [selectedDaybookData, setSelectedDaybookData] = useState(null);
   const shouldSendCompanyIdDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook || false;
   const shouldSendCompanyIdAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyIdItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;
   const shouldSendCompanyIdWarehouse = userGlobalSettingsData?.[0]?.askCompany?.warehouse || false;
   const shouldSendCompanyidBillTerm = userGlobalSettingsData?.[0]?.askCompany?.bllTerm || false;

   const initialLineItem = useMemo(() => {
      return {
         typeOfSupply: 1,
         headerId: 1,
         gst: 0,
         netGst: 0,
         gstAmount: 0,
         itemId: null,
         lineNumber: 1,
         itemRate: 0,
         amount: 0,
         netAmount: 0,
         taxableAmount: 0,
         ratePer: 0,
         uomNoForRate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         qty1: 0,
         qty2: 0,
         qty3: 0,
         hsnData: company?.hsndata,
         sacData: company?.sacdata,
         ratio: null,

         addLess1Percent: 0,
         addLess1Amount: 0,
         addLess2Percent: 0,
         addLess2Amount: 0,
         addLess3Percent: 0,
         addLess3Amount: 0,

         stock: [],
         unit: null,
         qUnitId1: null,
         qUnitId2: null,
         qUnitId3: null,
         subHSNId: null,
         warehouseId: null,
         isDeleted: false,
         notes: '',
         remarks: '',
         gstWithRate: null,
         lotNumber: null,
         itemScreenId: null,
      };
   }, [company?.hsndata, company?.sacdata]);

   const [errors, setErrors] = useState({});
   const [billTerms, setBillTerms] = useState([]);
   const [stockList, setStockList] = useState([]);
   const [selectedStocks, setSelectedStocks] = useState([]);
   const [deleteLineItemId, setDeleteLineItemId] = useState(null);
   const [deleteLineItemIdx, setDeleteLineItemIdx] = useState(null);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [isSameState, setIsSameState] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
   const [isPageLoading, setIsPageLoading] = useState(true);
   const [currentLineItemIdx, setCurrentLineItemIdx] = useState(null);
   const [row, setRow] = useState({
      header: {
         daybookId: lastPurchaseReturnDaybook?.daybookId || '',
         docno: '',
         transactionAt: new Date().toISOString().split('T')[0],
         prefix: '',
         postFix: '',
         companyId: '',
         accountId: '',
         brokerId: '',
         basicAmount: 0,
         additionAmount: '',
         deductionAmount: '',
         netAmount: 0,
         dueDays: 0,
         dueAt: new Date().toISOString().split('T')[0],
         billtoStateId: null,
         shiptoStateId: null,
         warehouseId: null,
         partyNo: '',
         partyDate: new Date().toISOString().split('T')[0],
         originalBillNo: '',
         originalBillDate: '',
         notes: '',
         representativeId: user?.id,
         incomeId: null,
         tdsRate: null,
         tdsAmount: null,
      },
      lineItem: [initialLineItem],
   });

   const { id } = useParams();
   const toast = useToast();
   const dispatch = useDispatch();
   const textColor = useColorModeValue('gray.800', 'white');
   const navigate = useNavigate();

   const {
      totals,
      handleQtyChange,
      handleRateChange,
      handleDiscountChange,
      setTotalBillTermAmount,
      setBillTerm,
      finalNetAmount,
      handleItemChange,
      handleUnitChange,
   } = useCalculateTaxAmount({
      row,
      setRow,
      setBillTerms,
      invoiceType,
   });

   // get value in local storage
   const accountId = localStorage.getItem('accountId');
   const daybookId = localStorage.getItem('daybook');

   const lastClick = useRef(0);

   // Create refs for each input field
   const daybookRef = useRef(null);
   const docNoRef = useRef(null);
   const transactionAtRef = useRef(null);
   const accountRef = useRef(null);
   const tdsRateRef = useRef(null);
   const tdsAmountRef = useRef(null);
   const incomeRef = useRef(null);
   const brokerRef = useRef(null);
   const partyBillNoRef = useRef(null);
   const partyDateRef = useRef(null);
   const originalBillNoRef = useRef(null);
   const originalDateRef = useRef(null);
   const supplierRef = useRef(null);
   const wareHouseRef = useRef(null);
   const dueDaysRef = useRef(null);
   const dueDateRef = useRef(null);
   const submitRef = useRef(null);
   const closeRef = useRef(null);
   const notesRef = useRef(null);
   const lineItemNotesRef = useRef(null);
   const lineItemRemarkRef = useRef(null);
   const warehouseRef = useRef([]);
   const itemRefs = useRef([]);
   const qty1Refs = useRef([]);
   const qty2Ref = useRef([]);
   const qty3Ref = useRef([]);
   const rateRefs = useRef([]);
   const gstRateRefs = useRef([]);
   const gstTaxableRefs = useRef([]);
   const percentageRefs = useRef([]);
   const amountRefs = useRef([]);
   const itemScreenIdRefs = useRef([]);
   const lotNumberRefs = useRef([]);
   const subamountRefs = useRef([]);
   const prefixRef = useRef(null);
   const suffixRef = useRef(null);
   const refs = {
      warehouseRef,
      itemRefs,
      qty1Refs,
      qty2Ref,
      qty3Ref,
      rateRefs,
      percentageRefs,
      subamountRefs,
      amountRefs,
      dueDaysRef,
      lineItemNotesRef,
      lineItemRemarkRef,
      gstRateRefs,
      gstTaxableRefs,
      itemScreenIdRefs,
      lotNumberRefs,
   };

   const daybook = useMemo(() => {
      return daybookData?.filter((item) => item.type === 12).find((daybook) => daybook.id === row.header.daybookId);
   }, [daybookData, row.header.daybookId]);

   const pendingPayment = useMemo(() => {
      let badgeColor = 'blue.400';
      let borderColor = 'blue.400';

      if (salesInvoice?.pendingstatus === 'FULL PENDING') {
         badgeColor = 'orange.400';
         borderColor = 'orange.400';
      } else if (salesInvoice?.pendingstatus === 'CLEAR') {
         badgeColor = 'green.400';
         borderColor = 'green.400';
      } else if (salesInvoice?.pendingstatus === 'PART PENDING') {
         badgeColor = 'blue.400';
         borderColor = 'blue.400';
      }

      return { badgeColor, borderColor };
   }, [salesInvoice?.pendingstatus]);

   const account = useMemo(() => {
      return accountData.find((account) => account.id === row.header.accountId);
   }, [accountData, row.header.accountId]);

   const incomeacc = useMemo(() => {
      return incomeAccounts.find((account) => account.id === row.header.incomeId);
   }, [incomeAccounts, row.header.incomeId]);

   const daybookacc = useMemo(() => {
      return accountData.find((account) => account.id === daybook?.accountId);
   }, [accountData, daybook?.accountId]);

   const accTds = account && account?.tdsApplicable && account?.tdsAccountId ? true : false;
   const daybookTds = (daybook && row.header.incomeId && incomeacc?.tdsApplicable && incomeacc?.tdsAccountId)
      ? true
      : (daybook && daybook?.accountId && daybookacc?.tdsApplicable && daybookacc?.tdsAccountId)
         ? true
         : false;

   const showTds = accTds && daybookTds;

   useEffect(() => {
      if (showTds) {
         const TDSApplyOn = daybook?.TDSApplyOn;
         const TDSRate = row.header?.tdsRate ? row.header?.tdsRate : account?.tdsRate;
         if (TDSRate && TDSApplyOn !== null && TDSRate > 0) {
            setRow(prev => {
               console.log("prev header", prev.header);
               const netAmount = Number(finalNetAmount ?? prev.header?.netAmount ?? 0);
               const taxableAmount = Number(totals.taxableAmount ?? prev.header?.taxableAmount ?? 0);

               // decide base amount
               const baseAmount = TDSApplyOn === 0 ? netAmount : taxableAmount;

               // calculate TDS amount
               const tdsAmount = (baseAmount * TDSRate) / 100;

               return {
                  ...prev,
                  header: {
                     ...prev.header,
                     tdsRate: TDSRate,
                     tdsAmount: Number(tdsAmount),
                  },
               };
            });
         }
      } else {
         setRow(prev => ({
            ...prev,
            header: {
               ...prev.header,
               tdsRate: null,
               tdsAmount: null,
            },
         }));
      }
   }, [setRow, showTds, row.header.accountId]);

   useEffect(() => {
      if (showTds) {
         const TDSApplyOn = daybook?.TDSApplyOn;
         const TDSRate = row.header?.tdsRate ? row.header?.tdsRate : account?.tdsRate;
         if (TDSRate && TDSApplyOn !== null && TDSRate > 0) {
            setRow(prev => {
               const netAmount = Number(finalNetAmount || 0);
               const taxableAmount = Number(totals.taxableAmount || 0);

               // decide base amount
               const baseAmount = TDSApplyOn === 0 ? netAmount : taxableAmount;

               // calculate TDS amount
               const tdsAmount = (baseAmount * TDSRate) / 100;

               return {
                  ...prev,
                  header: {
                     ...prev.header,
                     tdsAmount: Number(tdsAmount),
                  },
               };
            });
         }
      }
   }, [setRow, row.header.netAmount, row.header?.tdsRate, totals.taxableAmount, finalNetAmount]);

   const handleKeyDown = (e, nextRef, preRef) => {
      if ((e.key === 'Enter' && !e.shiftKey) || (e.key === 'Tab' && !e.shiftKey)) {
         e.preventDefault();
         if (nextRef && nextRef?.current) {
            nextRef?.current?.focus();
         }
      }
      if (e.key === 'Tab' && e.shiftKey) {
         e.preventDefault();
         if (preRef && preRef?.current) {
            preRef?.current?.focus();
         }
      }
   };

   const prepareRowRefs = (count) => {
      warehouseRef.current = Array(count)
         .fill()
         .map((_, i) => warehouseRef.current[i] || createRef());

      itemRefs.current = Array(count)
         .fill()
         .map((_, i) => itemRefs.current[i] || createRef());

      qty1Refs.current = Array(count)
         .fill()
         .map((_, i) => qty1Refs.current[i] || createRef());

      rateRefs.current = Array(count)
         .fill()
         .map((_, i) => rateRefs.current[i] || createRef());

      gstRateRefs.current = Array(count)
         .fill()
         .map((_, i) => gstRateRefs.current[i] || createRef());

      gstTaxableRefs.current = Array(count)
         .fill()
         .map((_, i) => gstTaxableRefs.current[i] || createRef());
      lineItemNotesRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemNotesRef?.current?.[i] || createRef());

      lineItemRemarkRef.current = Array(count)
         ?.fill()
         ?.map((_, i) => lineItemRemarkRef?.current?.[i] || createRef());

      itemScreenIdRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => itemScreenIdRefs?.current?.[i] || createRef());

      lotNumberRefs.current = Array(count)
         ?.fill()
         ?.map((_, i) => lotNumberRefs?.current?.[i] || createRef());
   };

   const prepareBillTermRowRefs = (count) => {
      percentageRefs.current = Array(count)
         .fill()
         .map((_, i) => percentageRefs.current[i] || createRef());

      amountRefs.current = Array(count)
         .fill()
         .map((_, i) => amountRefs.current[i] || createRef());
   };

   const validateForm = useCallback(async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (error) {
         if (error instanceof Yup.ValidationError) {
            const newErrors = {};
            error.inner.forEach((err) => {
               newErrors[err.path] = err.message;
            });
            setErrors(newErrors);
            return false;
         }
         return false;
      }
   }, [row]);

   useEffect(() => {
      if (user && user.isExpired) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      const purchaseReturnRight = Array.isArray(user?.userRights)
         ? user.userRights.find((right) => right.companyId === user?.loginhistory?.companyId)?.purchasereturn
         : null;

      if (user && !user?.isAdmin) {
         if (window.location.pathname.includes('purchase/return/add') && purchaseReturnRight) {
            if (purchaseReturnRight?.add !== true) {
               window.history.back();
            }
         } else if (window.location.pathname.includes('purchase/return/edit') && purchaseReturnRight) {
            if (purchaseReturnRight?.edit !== true) {
               window.history.back();
            }
         }
      }
   }, [user]);

   useEffect(() => {
      const handleKeyDown = (event) => {
         // Check for Ctrl+S (or Cmd+S on Mac)
         if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            // Completely prevent default browser behavior
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            // Trigger form submit
            if (!isLoading) {
               handleSubmit();
            }
            // Prevent any other handlers from running
            return false;
         }
      };

      // Add event listeners at multiple levels for complete coverage
      document.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });
      window.addEventListener('keydown', handleKeyDown, { capture: true, passive: false });

      // Cleanup function
      return () => {
         document.removeEventListener('keydown', handleKeyDown, { capture: true });
         window.removeEventListener('keydown', handleKeyDown, { capture: true });
      };
   }, [row, isLoading]);

   const handleStockModalOnClick = useCallback(
      async (index) => {
         const itemData = row.lineItem[Number(index)];
         if (itemData?.itemId && user?.loginhistory?.companyId && row.header.accountId) {
            await dispatch(
               getStock({
                  itemId: Number(itemData?.itemId),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: row.header.accountId,
                  isReceiveStock: false,
                  type: 'purchase_return',
               }),
            );
            setStockList((prev) => getUniqueByStock(prev.concat(itemData?.stock)));
            onOpenModal();
         }
      },
      [dispatch, onOpenModal, row.lineItem, user?.loginhistory?.companyId],
   );

   const handleDaybook = async (name, value) => {
      const newRow = { ...row };
      setDaybookId(Number(value));
      await dispatch(getBillTerm({
         daybookId: Number(value),
         ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
      }));

      const selectedDb = daybookData?.find((db) => db.id === Number(value));

      // ✅ Add mode AND Edit mode dono mein prefix/suffix update
      if (selectedDb) {
         const sep = selectedDb.separator || '';
         const cleanPrefix = sep
            ? (selectedDb.prefix || '').replace(new RegExp(sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', ''), '')
            : (selectedDb.prefix || '');
         const cleanSuffix = sep
            ? (selectedDb.suffix || '').replace(new RegExp('^' + sep.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ''), '')
            : (selectedDb.suffix || '');
         newRow.header.prefix = cleanPrefix;
         newRow.header.postFix = cleanSuffix;
         setOriginalPrefix(cleanPrefix);
         setOriginalPostFix(cleanSuffix);
      }

      newRow.header[name] = value;
      setRow({ ...newRow });
      setErrors((prev) => {
         const obj = { ...prev };
         const fullName = `header.${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleAccount = async (name, value) => {
      if (name === 'accountId' && value !== null) {
         const newRow = { ...row };
         const accountId = value?.id ? value?.id : value;
         newRow.header[name] = accountId;
         if (id) {
            if (value === salesInvoice?.accountId) {
               newRow.lineItem = [...newRow.lineItem.filter((item) => item.id).map((item) => ({ ...item, isDeleted: false }))];
            } else {
               newRow.lineItem = [...newRow.lineItem.filter((item) => item.itemId && item.id).map((item) => ({ ...item, isDeleted: true })), initialLineItem];
            }
         } else {
            newRow.lineItem = [initialLineItem];
         }
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.accountId'];
            return obj;
         });
         if (value && value !== '') {
            const res = await dispatch(
               getItemForMaster({
                  companyId: user?.loginhistory?.companyId,
                  ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                  accountId: value,
                  type: 'PURCHASE',
               }),
            );
            setItemData(res);
         } else {
            setItemData([]);
         }
      }
      if (name === 'accountId' && value === null) {
         const newRow = { ...row };
         const accountId = value?.id ? value?.id : value;
         newRow.header[name] = accountId;
         if (id) {
            newRow.lineItem = [...newRow.lineItem.map((item) => ({ ...item, isDeleted: true })), initialLineItem];
         } else {
            newRow.lineItem = [initialLineItem];
         }
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.accountId'];
            return obj;
         });
         setItemData([]);
      }
      if (name === 'warehouseId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         newRow.lineItem = newRow.lineItem.map((item) => ({
            ...item,
            [name]: value,
            stock: Array.isArray(item.stock)
               ? item.stock.map((stockItem) => ({
                  ...stockItem,
                  [name]: stockItem.warehouseId ? stockItem.warehouseId : value,
               }))
               : [], // fallback if stock is not array
         }));
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.brokerId'];
            return obj;
         });
      }
      if (name === 'brokerId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.brokerId'];
            return obj;
         });
      }

      if (name === 'representativeId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.representativeId'];
            return obj;
         });
      }

      if (name === 'incomeId') {
         const newRow = { ...row };
         newRow.header[name] = value;
         setRow(newRow);
         setErrors((prev) => {
            const obj = prev;
            delete obj['header.incomeId'];
            return obj;
         });
      }
   };

   const handleStockModal = useCallback(
      (itemId, index) => {
         const selectedItem = itemData?.find((item) => item.id.toString() === itemId.toString());
         if (selectedItem && selectedItem.itemdetailtype === 1) {
            onOpenModal();
         }
      },
      [itemData, onOpenModal],
   );

   const handleSerialHistory = (item) => {
      setSelectedItem(item);
      dispatch(getSerialWiseHistory({ companyIds: user?.loginhistory?.companyId, serialNo: item.serialNo }));
   };

   useEffect(() => {
      if (selectedItem && serialWiseHistory) {
         const historyForItem = serialWiseHistory?.flatMap((data) =>
            data.items
               .filter((subdata) => subdata.item_id === selectedItem.itemId)
               .flatMap((subdata) => subdata.transactions),
         );
         setData(historyForItem);
         onOpenSerialhistory();
      }
   }, [serialWiseHistory, selectedItem]);

   const handleAdjustedDocs = () => {
      dispatch(
         getAdjustedDocs({
            companyId: user?.loginhistory?.companyId,
            spId: id,
            daybookId: row.header.daybookId,
            accountId: row.header.accountId,
            type: 'PURCHASE RETURN',
         }),
      );
      const selectedDaybookData = daybookData.filter((item) => item.id === row.header.daybookId);
      setSelectedDaybookData(selectedDaybookData);
      onOpenAdjustedDocs();
   };

   const handleOnChange = async (header, name, value, idx) => {
      const newRow = { ...row };
      const lineItem = newRow.lineItem[idx];

      if (['qty1', 'qty2', 'qty3'].includes(name)) {
         handleQtyChange(name, value, idx);
      }
      if (name === 'itemRate') {
         const gstRate = getGstRate(value, newRow, header, idx);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange(name, value, idx);
      }
      if (name === 'gstWithRate') {
         const gstRate = Number(value || 0);
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const itemRate = gstRate / (1 + gstPercent / 100);
         handleRateChange('itemRate', Number(itemRate || 0)?.toFixed(2), idx);
      }
      if (name === 'amount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (name === 'taxableAmount') {
         const selectedItem = itemData.find((i) => i.id === newRow[header][idx].itemId);
         const unit = newRow[header][idx].unit;
         const qty =
            unit === selectedItem?.uqc1Data?.id
               ? newRow[header][idx].qty1
               : unit === selectedItem?.uqc2Data?.id
                  ? newRow[header][idx].qty2
                  : unit === selectedItem?.uqc3Data?.id
                     ? newRow[header][idx].qty3
                     : newRow[header][idx].qty1;
         const itemRate = Number(value || 0) / qty;
         const gstPercent = Number(newRow[header][idx].gst || 0);
         const gstRate = itemRate * (1 + gstPercent / 100);
         newRow[header][idx].gstWithRate = gstRate;
         handleRateChange('itemRate', itemRate, idx);
      }
      if (['addLess1Percent', 'addLess2Percent', 'addLess3Percent'].includes(name)) {
         handleDiscountChange(name, value, idx);
      }

      if (name === 'unit') {
         handleUnitChange(value, idx);
      }

      if (name === 'itemId') {
         // await dispatch(
         //    getItem({
         //       companyId: user?.loginhistory.companyId,
         //       sortBy: 'name',
         //       sortOrder: 'asc',
         //    }),
         // );
         const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].unit = selectedItem?.rateperpurchaseid;
         handleQtyChange('qty1', 0, idx);
         handleQtyChange('qty2', 0, idx);
         handleQtyChange('qty3', 0, idx);
         handleRateChange('itemRate', 0, idx);
         handleDiscountChange('addLess1Percent', 0, idx);
         handleDiscountChange('addLess2Percent', 0, idx);
         handleDiscountChange('addLess3Percent', 0, idx);
         handleItemChange(name, value, idx, 'purchasereturn');
         if (value && row?.header?.accountId && user?.loginhistory?.companyId) {
            await dispatch(
               getStock({
                  itemId: Number(value),
                  companyId: user?.loginhistory?.companyId,
                  accountId: row.header.accountId,
                  isReceiveStock: false,
                  type: 'purchase_return',
               }),
            );
            newRow.lineItem[idx].stock = [];
            handleStockModal(value, idx);
         }
      }

      if (name === 'itemScreenId') {
         // const selectedItem = itemData.find((x) => x.id === Number(value));
         newRow[header][idx].itemScreenId = Number(value);
      }

      if (name === 'lotNumber') {
         newRow[header][idx].lotNumber = Number(value);
      }
      const daybook = filteredDaybooks.find((item) => item.id === row?.header?.daybookId);
      let subHsn;
      if (company?.setting?.applyGST && daybook?.applyGst && newRow[header][idx].itemId) {
         if (name === 'typeOfSupply') {
            if (value === 1) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.hsnData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            if (value === 2) {
               if (lineItem?.hsnData?.subHsn?.length === 1) {
                  subHsn = lineItem?.hsnData?.subHsn[0];
               } else {
                  subHsn = lineItem?.sacData?.subHsn?.find(
                     (hsn) => lineItem.itemRate >= hsn.fromRate && lineItem.itemRate <= hsn.toRate,
                  );
               }
            }
            const taxRate = parseFloat(subHsn?.gst) / 100;
            newRow[header][idx].gst = subHsn?.gst ?? 0;
            newRow[header][idx].subHSNId = subHsn?.id ?? null;
            newRow[header][idx].gstAmount = lineItem.itemRate * lineItem.qty1 * taxRate;
            newRow[header][idx].ratio = subHsn?.ratio ?? null;
         }
      }
      newRow[header][idx][name] = value;
      setRow(newRow);
      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}[${idx}].${name}`;
         delete obj[fullName];
         return obj;
      });
   };

   const handleBillTermChange = useCallback(
      (index, values) => {
         setBillTerms((prev) => {
            const newBillTerms = [...prev];
            newBillTerms[index] = {
               ...newBillTerms[index],
               ...values,
            };
            // Get the current basic amount
            const currentBasicAmount = parseFloat(row.header.basicAmount) || 0;

            // Calculate addition and deduction totals based on the basic amount
            let additionTotal = 0;
            let deductionTotal = 0;

            newBillTerms.forEach((term, idx) => {
               const amount = parseFloat(term.amount) || 0;
               const termData = billTermData[idx];

               if (termData?.signname === 'Subtraction') {
                  deductionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Addition') {
                  additionTotal += Math.abs(amount);
               } else if (termData?.signname === 'Both') {
                  if (amount < 0) {
                     deductionTotal += Math.abs(amount);
                  } else {
                     additionTotal += amount;
                  }
               }
            });

            // Calculate net amount based on the basic amount
            const netAmount = currentBasicAmount + additionTotal - deductionTotal;

            let billTerm = additionTotal - deductionTotal;
            let netTotal = totals.netAmount + additionTotal;
            netTotal = netTotal - deductionTotal;
            setBillTerm(billTerm);
            setTotalBillTermAmount(netTotal);

            // Update the header amounts
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  additionAmount: additionTotal.toFixed(2),
                  deductionAmount: deductionTotal.toFixed(2),
                  netAmount: netAmount.toFixed(2),
                  basicAmount: currentBasicAmount.toFixed(2),
               },
            }));

            return newBillTerms;
         });
      },
      [billTermData, row.header.basicAmount, setBillTerm, setTotalBillTermAmount, totals.netAmount],
   );

   const addLineItem = () => {
      // setRow((prev) => ({
      //    ...prev,
      //    lineItem: [...prev?.lineItem, { ...initialLineItem }],
      // }));
      setRow((prev) => ({
         ...prev,
         lineItem: [...prev?.lineItem, {
            typeOfSupply: 1,
            headerId: 1,
            gst: 0,
            netGst: 0,
            gstAmount: 0,
            itemId: null,
            lineNumber: 1,
            itemRate: 0,
            amount: 0,
            netAmount: 0,
            taxableAmount: 0,
            ratePer: 0,
            uomNoForRate: 0,
            salesprice1: 0,
            salesprice2: 0,
            salesprice3: 0,
            qty1: 0,
            qty2: 0,
            qty3: 0,
            hsnData: company?.hsndata,
            sacData: company?.sacdata,
            ratio: null,
            addLess1Percent: 0,
            addLess1Amount: 0,
            addLess2Percent: 0,
            addLess2Amount: 0,
            addLess3Percent: 0,
            addLess3Amount: 0,
            stock: [],
            unit: null,
            qUnitId1: null,
            qUnitId2: null,
            qUnitId3: null,
            subHSNId: null,
            warehouseId: null,
            isDeleted: false,
            notes: '',
            remarks: '',
            gstWithRate: null,
         }],
      }));
   };

   const removeLineItem = (index, id) => {
      // if (id) {
      //    setDeleteLineItemId(id);
      //    setDeleteDialogOpen(true);
      //    setDeleteLineItemIdx(index);
      //    setCurrentLineItemIdx(index);
      // } else {
      //    setRow((prev) => ({
      //       ...prev,
      //       lineItem: prev.lineItem.filter((_, i) => i !== index),
      //    }));
      // }
      if (id) {
         Swal.fire({
            title: 'Are you sure?',
            text: `This entry is marked for removal/emptying. Please ensure this entry is saved permanently before proceeding.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
         }).then((result) => {
            if (result.isConfirmed) {
               setRow((prev) => ({
                  ...prev,
                  lineItem: prev.lineItem
                     .map((li, idx) => {
                        if (!li.itemId) return null;
                        return li.id === id ? { ...li, isDeleted: true } : li;
                     })
                     .filter(Boolean),
               }));
            }
         });
      } else {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== index),
         }));
      }
   };

   const handleDelete = () => {
      if (deleteLineItemId) dispatch(deletePurchaseReturnLineItem(deleteLineItemId));
      if (deleteLineItemIdx >= 0) {
         setRow((prev) => ({
            ...prev,
            lineItem: prev.lineItem.filter((_, i) => i !== deleteLineItemIdx),
         }));
      }
      setDeleteLineItemId(null);
      setDeleteLineItemIdx(null);
      setDeleteDialogOpen(false);
      setCurrentLineItemIdx(null);
   };

   const removeStock = useCallback(
      (stock) => {
         const updatedLineItem = row.lineItem.map((lineItem, idx) => {
            const selectedItem = itemData.find((i) => i.id === lineItem.itemId);
            const stockData = lineItem.stock.filter((s) => s.serialNo !== stock.serialNo);
            const qty1 = stockData?.length;

            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 === 0) {
               handleQtyChange('qty1', qty1, idx);
               itemRefs.current[idx].focus();
               return { ...lineItem, itemId: '', stock: [], qty1: qty1, itemRate: 0 };
            }
            if (selectedItem && selectedItem?.itemdetailtype === 1 && qty1 > 0) {
               handleQtyChange('qty1', qty1, idx);
               return { ...lineItem, stock: stockData, qty1: qty1 };
            }

            return lineItem;
         });

         setRow((prev) => ({
            ...prev,
            lineItem: updatedLineItem,
         }));
      },
      [handleQtyChange, itemData, row.lineItem],
   );

   const handleEditValues = useCallback(async () => {
      if (id && salesInvoice) {
         setRow({
            header: {
               daybookId: salesInvoice.daybookId,
               docno: salesInvoice.docno,
               transactionAt: salesInvoice.transactionAt
                  ? moment(salesInvoice.transactionAt, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : '',
               dueAt: salesInvoice?.dueAt
                  ? new Date(salesInvoice?.dueAt).toISOString().split('T')[0]
                  : new Date().toISOString().split('T')[0],
               dueDays: salesInvoice.dueDays,
               accountId: salesInvoice.accountId,
               basicAmount: salesInvoice.basicAmount,
               netAmount: salesInvoice.netAmount,
               partyNo: salesInvoice.partyNo,
               partyDate: salesInvoice.partyDate
                  ? moment(salesInvoice.transactionAt, 'DD/MM/YYYY').format('YYYY-MM-DD')
                  : '',
               originalBillNo: salesInvoice.originalBillNo,
               originalBillDate: salesInvoice.originalBillDate
                  ? moment(salesInvoice.originalBillDate).local().format('YYYY-MM-DD')
                  : '',
               notes: salesInvoice.notes,
               brokerId: salesInvoice.brokerId,
               representativeId: salesInvoice.representativeId,
               incomeId: salesInvoice.incomeId,
               tdsRate: salesInvoice.tdsRate,
               tdsAmount: salesInvoice.tdsAmount,
               prefix: salesInvoice.prefix,
               postFix: salesInvoice.postFix,
            },
            lineItem: salesInvoice.lineitems?.map((item, index) => {
               return {
                  ...item,
                  itemRate: item.itemRate?.toString(),
                  amount: item.amount,
                  typeOfSupply: Number(item.typeOfSupply),
                  netAmount: item.netAmount,
                  taxableAmount: item.taxableAmount,
                  ratio: item.ratio,
                  addLess1Percent: item.addLess1Percent,
                  addLess1Amount: item.addLess1Amount,
                  addLess2Percent: item.addLess2Percent,
                  addLess2Amount: item.addLess2Amount,
                  addLess3Percent: item.addLess3Percent,
                  addLess3Amount: item.addLess3Amount,
                  gst: item.gstPercent,
                  unit: item?.ratePer,
                  isDeleted: false,
                  notes: item.notes ? item.notes : '',
                  remarks: item.remarks ? item.remarks : '',
                  gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  stock: item.purchaseReturnLineDetail?.map((stock) => {
                     return {
                        ...stock,
                        pcs: stock.quantity1,
                     };
                  }),
               };
            }),
         });

         setOriginalPrefix(salesInvoice.prefix || '');
         setOriginalPostFix(salesInvoice.postFix || '')

         const res = await dispatch(
            getItemForMaster({
               companyId: user?.loginhistory?.companyId,
               ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
               accountId: salesInvoice.accountId,
               type: 'PURCHASE',
            }),
         );
         setItemData(res);

         const initialBillTerms = billTermData?.map((term) => {
            const billTerm = salesInvoice.purchasebillteams?.find((billTerm) => billTerm.billTermId === term.id);
            if (billTerm) {
               return {
                  id: billTerm?.id,
                  billTermId: term.id,
                  percentage: billTerm?.percentage || 0,
                  amount: billTerm?.amount || 0,
               };
            } else {
               return {
                  billTermId: term.id,
                  percentage: 0,
                  amount: 0,
               };
            }
         });
         setBillTerms(initialBillTerms);
      }
   }, [dispatch, id, salesInvoice, billTermData?.length]);
   // billTermData, dispatch, hasFetchedAccount, id, salesInvoice

   const handleInputChange = useCallback((header, e, idx) => {
      const { name, value } = e.target;

      setRow((prev) => ({
         ...prev,
         [header]: {
            ...prev[header],
            [name]: value,
         },
      }));

      if (name === 'dueDays') {
         setRow((prev) => {
            const transactionDate = prev[header]?.transactionAt ? moment(prev[header].transactionAt).clone() : moment(); // fallback if missing

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  dueAt: transactionDate.add(Number(value), 'days').format('YYYY-MM-DD'),
               },
            };
         });
      }

      if (name === 'dueAt') {
         setRow((prev) => {
            const transactionDate = prev[header]?.transactionAt; // "YYYY-MM-DD"

            const dueDate = moment(value, 'YYYY-MM-DD'); // user's selected due date
            const transDate = moment(transactionDate, 'YYYY-MM-DD');

            const diffDays = dueDate.diff(transDate, 'days'); // <-- main logic

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  dueDays: diffDays, // store difference in days
               },
            };
         });
      }

      if (name === 'transactionAt') {
         setRow((prev) => {
            const dueDays = Number(prev[header]?.dueDays || 0);

            // new transaction date user selected
            const transactionDate = moment(value, 'YYYY-MM-DD').clone();

            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  transactionAt: value,
                  dueAt: transactionDate.add(dueDays, 'days').format('YYYY-MM-DD'),
               },
            };
         });
      }

      if (name === 'tdsAmount') {
         setRow((prev) => {
            const TDSApplyOn = daybook?.TDSApplyOn;
            const netAmount = Number(finalNetAmount || salesInvoice?.netAmount || 0);
            const taxableAmount = Number(totals?.taxableAmount || salesInvoice?.taxableAmount || 0);
            const baseAmount = TDSApplyOn === 0 ? netAmount : taxableAmount;
            const tdsRate = (Number(value) / baseAmount) * 100;
            console.log("tdsRate", tdsRate, finalNetAmount, totals, salesInvoice);
            return {
               ...prev,
               [header]: {
                  ...prev[header],
                  tdsRate: tdsRate,
               },
            };
         });
      }

      setErrors((prev) => {
         const obj = prev;
         const fullName = `${header}.${name}`;
         delete obj[fullName];
         return obj;
      });
   }, []);

   const handleWarehouseId = useCallback(
      (warehouseId) => {
         const warehouseIn =
            daybook?.warehouseInId === 1 || companyData?.setting?.warehouseInPurchase === 1
               ? [1]
               : daybook?.warehouseInId === 2 || companyData?.setting?.warehouseInPurchase === 2
                  ? [1, 2]
                  : [1, 2, 3];
         if (companyData?.setting?.warehouseWishStock) {
            if (
               (warehouseIn.includes(daybook?.warehouseInId) ||
                  warehouseIn.includes(companyData?.setting?.warehouseInPurchase)) &&
               warehouseId &&
               warehouseId > 0
            )
               return warehouseId;
            if (warehouseIn.includes(daybook?.warehouseInId) && daybook?.wareHouseId && daybook?.wareHouseId > 0) {
               return daybook?.wareHouseId;
            }
            if (
               warehouseIn.includes(companyData?.setting?.warehouseInPurchase) &&
               companyData?.setting?.warehouseId &&
               companyData?.setting?.warehouseId > 0
            ) {
               return companyData?.setting?.warehouseId;
            }
         }
         return 1;
      },
      [companyData?.setting?.warehouseWishStock, daybook?.warehouseInId, daybook?.wareHouseId],
   );

   const saveData = _.debounce(
      async () => {
         const isValid = await validateForm();

         if (isValid) {
            const prefixChanged = row.header.prefix !== originalPrefix;
            const postFixChanged = row.header.postFix !== originalPostFix;

            if (prefixChanged || postFixChanged) {
               const result = await Swal.fire({
                  title: 'Prefix / Suffix Changed',
                  text: 'Do you want to update this change in the Daybook as well?',
                  icon: 'question',
                  showCancelButton: true,
                  confirmButtonText: 'Yes, Update Daybook',
                  cancelButtonText: 'No, Only This Bill',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#6c757d',
               });

               if (result.isConfirmed) {
                  // ✅ Update daybook prefix and suffix
                  const selectedDaybookToUpdate = daybookData?.find(
                     (db) => db.id === Number(row.header.daybookId)
                  );
                  if (selectedDaybookToUpdate) {
                     await dispatch(updateDaybook({
                        // ...selectedDaybookToUpdate,
                        id: selectedDaybookToUpdate.id,
                        name: selectedDaybookToUpdate.name,
                        type: Number(selectedDaybookToUpdate.type),
                        subType: Number(selectedDaybookToUpdate.subType) || 0,
                        accountId: Number(selectedDaybookToUpdate.accountId),
                        prefix: row.header.prefix,
                        suffix: row.header.postFix,
                     }));
                     // ✅ Update original values after daybook update
                     setOriginalPrefix(row.header.prefix);
                     setOriginalPostFix(row.header.postFix);
                  }
               }
            }
            setIsLoading(true);
            const payload = {
               header: {
                  ...row.header,
                  ...(id && { id: id }),
                  docno: row.header?.docno?.toString()?.trim(),
                  basicAmount: formatAmount(Number(totals.netAmount)),
                  netAmount: formatAmount(Math.round(Number(finalNetAmount))),
                  companyId: Number(user?.loginhistory?.companyId),
                  accountId: Number(row.header.accountId),
                  daybookId: Number(row.header.daybookId),
                  additionAmount: row.header.additionAmount ? Number(row.header.additionAmount) : 0,
                  deductionAmount: row.header.deductionAmount ? Number(row.header.deductionAmount) : 0,
                  dueDays: row.header.dueDays ? Number(row.header.dueDays) : 0,
                  partyNo: row.header.partyNo,
                  partyDate: moment(row.header.partyDate).format('YYYY-MM-DD'),
                  originalBillNo: row.header.originalBillNo,
                  originalBillDate: row.header.originalBillDate
                     ? moment(row.header.originalBillDate).format('YYYY-MM-DD')
                     : null,
                  transactionAt: moment(row.header.transactionAt).format('YYYY-MM-DD'),
                  dueAt: moment(row.header.dueAt).format('YYYY-MM-DD'),
                  gstAmount: totals.netGstAmount ? totals.netGstAmount : 0,
                  // warehouseId:
                  //    companyData?.setting?.warehouseWishStock === true && herderview === true
                  //       ? row.header.warehouseId === null
                  //          ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //          : row.header.warehouseId
                  //       : 1,
                  warehouseId: handleWarehouseId(row.header.warehouseId),
                  taxableAmount: totals.taxableAmount ? totals.taxableAmount : 0,
                  billtoStateId: getAccountAddress(accountData, row.header.accountId)?.billingAddress?.stateId ?? null,
                  shiptoStateId: getAccountAddress(accountData, row.header.accountId)?.shippingAddress?.stateId ?? null,
                  gstTxnType: getGstTaxType(company, account, 'purchase'),
                  gstSubTxnType: getGstSubTaxType(company, account, 'purchase'),
                  assesseType: companyList?.assesseType ? companyList?.assesseType : 0,
                  distance: companyList?.distanceKM ? companyList?.distanceKM : 0,
                  brokerId: row.header.brokerId || null,
                  notes: row.header.notes || null,
                  representativeId: row.header.representativeId || null,
                  incomeId: row.header.incomeId || null,
                  tdsRate: row.header.tdsRate || null,
                  tdsAmount: row.header.tdsAmount || null,
               },
               lineItem: row.lineItem?.map((item) => {
                  const selectedItem = itemData?.find((i) => i.id.toString() === item.itemId?.toString());
                  // const finalWarehouse =
                  //    companyData?.setting?.warehouseWishStock === true && herderview === true
                  //       ? row.header.warehouseId === null
                  //          ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //          : row.header.warehouseId
                  //       : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                  //          ? item.warehouseId === null
                  //             ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //             : item.warehouseId
                  //          : 1;

                  // const finalStockWarehouse =
                  //    companyData?.setting?.warehouseWishStock === true && herderview === true
                  //       ? row.header.warehouseId === null
                  //          ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //          : row.header.warehouseId
                  //       : companyData?.setting?.warehouseWishStock === true && lineitemview === true
                  //          ? item.warehouseId === null
                  //             ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //             : item.warehouseId
                  //          : companyData?.setting?.warehouseWishStock === true && lineDetailview === true
                  //             ? item.warehouseId === null
                  //                ? selectdaybookdata?.wareHouseId ?? companyData?.setting?.warehouseId ?? 1
                  //                : item.warehouseId
                  //             : 1;
                  return {
                     ...(item.id && { id: item.id }),
                     typeOfSupply: item.typeOfSupply ? item.typeOfSupply : 1,
                     itemId: item.itemId ? Number(item.itemId) : 0,
                     lineNumber: item.lineNumber ? Number(item.lineNumber) : 1,
                     itemRate: item.itemRate ? Number(item.itemRate) : 0,
                     amount: item.amount ? Number(item.amount) : 0,
                     netAmount: item.netAmount ? formatAmount(Number(item.netAmount)) : 0,
                     // ratePer: selectedItem.rateperpurchaseid ? Number(selectedItem.rateperpurchaseid) : 0,
                     // uomNoForRate:
                     //    selectedItem?.uqcid1 === selectedItem?.rateperpurchaseid
                     //       ? 1
                     //       : selectedItem?.uqcid2 === selectedItem?.rateperpurchaseid
                     //       ? 2
                     //       : selectedItem?.uqcid3 === selectedItem?.rateperpurchaseid
                     //       ? 3
                     //       : 1,

                     ratePer: item.unit && item.unit > 0 ? item.unit : selectedItem.rateperpurchaseid,
                     uomNoForRate:
                        item.unit > 0 && item.unit === selectedItem.uqcid1
                           ? 1
                           : item.unit > 0 && item.unit === selectedItem.uqcid2
                              ? 2
                              : item.unit > 0 && item.unit === selectedItem.uqcid3
                                 ? 3
                                 : 1,
                     qUnitId1: selectedItem?.uqcid1,
                     qUnitId2: selectedItem?.uqcid2,
                     qUnitId3: selectedItem?.uqcid3,
                     qty1: item.qty1 ? Number(item.qty1) : 0,
                     qty2: item.qty2 ? Number(item.qty2) : 0,
                     qty3: item.qty3 ? Number(item.qty3) : 0,
                     addLess1Percent: item.addLess1Percent ? Number(item.addLess1Percent) : 0,
                     addLess1Amount: item.addLess1Amount ? item.addLess1Amount : 0,
                     addLess2Percent: item.addLess2Percent ? Number(item.addLess2Percent) : 0,
                     addLess2Amount: item.addLess2Amount ? item.addLess2Amount : 0,
                     addLess3Percent: item.addLess3Percent ? Number(item.addLess3Percent) : 0,
                     addLess3Amount: item.addLess3Amount ? item.addLess3Amount : 0,
                     taxableAmount: item.taxableAmount ? item.taxableAmount : 0,
                     netGst: item.netGst ? item.netGst : 0,
                     gstPercent: item.gst ? item.gst : 0,
                     cgst: isSameState ? totals.netGstAmount / 2 : 0,
                     sgst: isSameState ? totals.netGstAmount / 2 : 0,
                     igst: isSameState ? 0 : totals.netGstAmount,
                     hsnId: selectedItem?.hsnid,
                     sacId: selectedItem?.sacid,
                     stock:
                        item.stock?.length > 0
                           ? item.stock.map((s) => ({
                              ...s,
                              // warehouseId: s.warehouseId ? s.warehouseId : finalStockWarehouse,
                              warehouseId: handleWarehouseId(s.warehouseId),
                              returnStatus: undefined,
                              warehouseName: undefined,
                           }))
                           : [],
                     subHSNId: item.subHSNId ?? null,
                     // warehouseId: finalWarehouse,
                     warehouseId: handleWarehouseId(item.warehouseId),
                     isDeleted: item.isDeleted ? item.isDeleted : false,
                     notes: item.notes ? item.notes : null,
                     remarks: item.remarks ? item.remarks : null,
                     gstWithRate: item.gstWithRate ? item.gstWithRate : null,
                  };
               }),
               purchaseBillTerms: billTerms?.map((term) => ({
                  ...(term.id && { id: term.id }),
                  billTermId: Number(term.billTermId),
                  percentage: Number(term.percentage),
                  amount: Number(term.amount),
               })),
            };

            const newPayload = { ...payload };
            newPayload.lineItem = newPayload?.lineItem?.map((item) => {
               const ldWarehouseIds = new Set(item?.stock?.map((stock) => stock?.warehouseId));
               const warehouseId = ldWarehouseIds.values().next().value;
               return {
                  ...item,
                  // warehouseId: ldWarehouseIds.size > 1 ? item?.warehouseId : warehouseId,
                  warehouseId: ldWarehouseIds.size > 1 ? 1 : warehouseId,
               };
            });

            const warehouseIds = new Set(newPayload?.lineItem?.map((item) => item?.warehouseId));
            const warehouseId = warehouseIds.values().next().value;
            // newPayload.header.warehouseId = warehouseIds.size > 1 ? newPayload?.header?.warehouseId : warehouseId
            newPayload.header.warehouseId = warehouseIds.size > 1 ? 1 : warehouseId;

            let res;
            if (id) {
               res = await dispatch(updatePurchaseReturnInvoice(newPayload));
            } else {
               res = await dispatch(addPurchaseReturnInvoice(newPayload));
            }

            console.log('res123123', res?.data?.purchaseReturnLineDetail)

            if (res?.code === 2) {
               setIsLoading(false);
               return;
            }

            if (res?.code === 1) {
               if (user?.loginhistory?.companyId) {
                  dispatch(
                     getDaybook({
                        companyId: Number(user?.loginhistory?.companyId),
                        ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getItem({
                        companyId: user?.loginhistory.companyId,
                        sortBy: 'name',
                        sortOrder: 'asc',
                        ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
                  dispatch(
                     getAccount({
                        compId: Number(user?.loginhistory?.companyId),
                        accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
                        status: true,
                        ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
                     }),
                  );
               }

               // Block serial numbers confirmation
               const blockSerialResult = await Swal.fire({
                  title: 'Do you want to block these serial numbers?',
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  cancelButtonColor: '#d33',
                  confirmButtonColor: '#3085d6',
                  focusCancel: true,
               });

               // Proceed with print / navigation (called after block modal closes or user clicks No)
               const proceedAfterBlock = async () => {
                  if (daybook?.onlinePrinting) {
                     if (daybook?.askBeforePrint) {
                        Swal.fire({
                           title: 'Do you want to Print Document?',
                           showCancelButton: true,
                           confirmButtonText: 'Yes',
                           cancelButtonText: 'No',
                           cancelButtonColor: '#d33',
                           confirmButtonColor: '#3085d6',
                        }).then(async (result) => {
                           if (result.isConfirmed) {
                              if (daybook?.printingSettings === 0) {
                                 await dispatch(
                                    getSetupFormat({
                                       companyId: user?.loginhistory?.companyId,
                                       daybookId: row.header.daybookId,
                                       functionName: 'Purchase Returns',
                                    }),
                                 );

                                 const defaultFormat = prints.find((a) => a.isDefault);
                                 if (defaultFormat) {
                                    const result = await dispatch(
                                       setupFormatCustomQuery({
                                          query: defaultFormat?.PrintFormat?.query,
                                       }),
                                    );
                                    if (result && result?.data && result?.data?.length > 0) {
                                       const html = injectDataIntoHtml(defaultFormat?.PrintFormat?.html, result?.data);
                                       handleReset();
                                       handlePrintClick(
                                          {},
                                          html,
                                          defaultFormat?.PrintFormat?.css,
                                          navigate,
                                          '/admin/purchase/return',
                                       );
                                    }
                                 }
                              } else {
                                 onOpenPrintFormatModal();
                              }
                           }

                           if (result.isDismissed) {
                              dispatch(emptyPurchaseReturn());
                              await dispatch(
                                 getPurchaseReturnInvoices({
                                    page: 1,
                                    limit: 10,
                                    companyId: user?.loginhistory?.companyId,
                                    sortBy: 'id',
                                    sortOrder: 'desc',
                                 }),
                              );
                              localStorage.removeItem('daybook');
                              localStorage.removeItem('accountId');
                              setIsLoading(false);
                              handleReset();
                              navigate('/admin/purchase/return');
                              return;
                           }
                        });
                        return;
                     }
                  }

                  dispatch(emptyPurchaseReturn());
                  await dispatch(
                     getPurchaseReturnInvoices({
                        page: 1,
                        limit: 10,
                        companyId: user?.loginhistory?.companyId,
                        sortBy: 'id',
                        sortOrder: 'desc',
                     }),
                  );
                  localStorage.removeItem('daybook');
                  localStorage.removeItem('accountId');
                  setIsLoading(false);
                  handleReset();
                  navigate('/admin/purchase/return');
               };

               if (blockSerialResult.isConfirmed) {
                  // --- YES: open the block serial modal ---
                  const serialsToBlock = res?.data?.lineitems
                     .filter((li) => li.purchaseReturnLineDetail && li.purchaseReturnLineDetail.length > 0)
                     .flatMap((li) => li.purchaseReturnLineDetail);
                  setPostBlockAction(() => proceedAfterBlock);
                  setPendingBlockSerials(serialsToBlock);
                  onOpenSerialBlockModal();
                  setIsLoading(false);
                  // navigation is handled by the modal's onSuccess / onClose
               } else {
                  // --- NO: skip blocking, go straight to print / navigate ---
                  await proceedAfterBlock();
               }
            }
            setIsLoading(false);
         } else {

            setIsLoading(false);
            toast({
               title: 'Validation Error',
               description: getFirstErrorMessage(errors),
               status: 'error',
               duration: 3000,
               isClosable: true,
            });

            try {
               await validationSchema.validate(row, { abortEarly: false });
            } catch (validationError) {
               if (validationError instanceof Yup.ValidationError) {
                  const newErrors = {};
                  validationError.inner.forEach((err) => {
                     newErrors[err.path] = err.message;
                  });

                  setTimeout(() => {
                     if (newErrors['header.partyNo']) {
                        partyBillNoRef.current?.focus();
                     } else if (newErrors['header.daybookId']) {
                        daybookRef.current?.focus();
                     } else if (newErrors['header.docno']) {
                        docNoRef.current?.focus();
                     } else if (newErrors['header.transactionAt']) {
                        transactionAtRef.current?.focus();
                     } else if (newErrors['header.accountId']) {
                        accountRef.current?.focus();
                     } else if (newErrors['header.partyDate']) {
                        partyDateRef.current?.focus();
                     }
                  }, 100);
               }
            }
         }
      },
      500,
      { leading: true, trailing: true },
   );

   const handleSubmit = async () => {
      setIsLoading(true);
      const now = Date.now();
      // if (now - lastClick.current < 1000) return;
      if (now - lastClick.current < 1000) {
         setIsLoading(false); // ✅ Add this
         return;
      }
      lastClick.current = now;
      const financialYear = financialYears.find((a) => a.financial_year === user?.financialYear);

      const data = {
         daybookId: row.header.daybookId,
         docno: row.header.docno,
         fromDate: moment(financialYear?.fy_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         toDate: moment(financialYear?.fy_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
         companyId: user?.loginhistory?.companyId,
      };
      if (id) data.id = Number(id);
      const res = await dispatch(checkDocNo(data));
      if (res && res.code === 1 && res.data?.isError) {
         Swal.fire({
            title: res?.data?.message,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
         }).then(async (result) => {
            if (result.isConfirmed) {
               const newRow = { ...row };
               newRow.header.docno = res.data?.newDocNo.toString();
               newRow.header.partyNo = company?.setting?.partynoequaltodocno
                  ? res.data?.newDocNo.toString()
                  : newRow.header.partyNo;
               setRow(newRow);
               await saveData();
            }

            if (result.isDismissed) {
               setIsLoading(false);
               return;
            }
         });
      } else if (res && res.code === 1 && !res.data?.isError) {
         await saveData();
      } else {
         setIsLoading(false);
      }
   };

   const handleSelectStock = useCallback(
      (stocks) => {
         const firstWarehouse = warehouseList.find((wh) => wh.id === 1);
         const newStock = stocks.map((stock) => {
            return {
               itemId: stock.itemId,
               itemName: stock.itemName,
               pcs: stock.pcs,
               serialNo: stock.serialNo,
               serialNo2: stock.serialNo2,
               barcode: stock.barcode,
               warehouseName: stock.warehouseName ? stock.warehouseName : firstWarehouse ? firstWarehouse?.name : '',
               warehouseId: stock.warehouseId ?? 1,
               isOld: stock.isOld,
               purchaseLineDetailId:
                  stock.daybooktype === 11
                     ? stock.id
                     : stock?.purchaseLineDetailId
                        ? stock?.purchaseLineDetailId
                        : null,
               salesReturnLineDetailId:
                  stock.daybooktype === 6
                     ? stock.id
                     : stock?.salesReturnLineDetailId
                        ? stock?.salesReturnLineDetailId
                        : null,
               itemRate: stock.itemRate,
               latest_transaction_type: stock.latest_transaction_type,
               gstWithRate: stock.gstWithRate,
               account: stock.account,
               transactionAt: stock.transactionAt,
               finalItemCost: stock.finalItemCost,
            };
         });

         const newRow = { ...row }
         const stockData = [...newStock];


         const firstRate = stocks?.[0]?.finalItemCost;
         const isSameRate = stocks.every((x) => x?.finalItemCost === firstRate);

         // const firstGstRate = stocks?.[0]?.gstWithRate;
         // const isSameGstRate = stocks.every((x) => x?.gstWithRate === firstGstRate);

         const gstRate = getGstRate(isSameRate ? firstRate : 0, newRow, "lineItem", currentLineItemIdx);
         newRow.lineItem[currentLineItemIdx].stock = stockData;
         newRow.lineItem[currentLineItemIdx].gstWithRate = gstRate;
         handleQtyChange('qty1', stockData?.length, currentLineItemIdx);
         handleRateChange('itemRate', isSameRate ? firstRate : 0, currentLineItemIdx);
         setRow(newRow);
      },
      [currentLineItemIdx],
   );


   const handleReset = useCallback(async () => {
      console.log('reset...');
      const initialRow = {
         header: {
            daybookId: lastPurchaseReturnDaybook?.daybookId || '',
            docno: '',
            transactionAt: new Date().toISOString().split('T')[0],
            prefix: '',
            postFix: '',
            companyId: '',
            accountId: '',
            brokerId: '',
            basicAmount: 0,
            additionAmount: '',
            deductionAmount: '',
            netAmount: 0,
            dueDays: 0,
            dueAt: new Date().toISOString().split('T')[0],
            billtoStateId: null,
            shiptoStateId: null,
            warehouseId: null,
            partyNo: '',
            partyDate: new Date().toISOString().split('T')[0],
            originalBillNo: '',
            originalBillDate: '',
            notes: '',
            representativeId: user?.id,
         },
         lineItem: [initialLineItem],
      };
      setRow(initialRow);
      setSelectedStocks([]);
      setBillTerms([]);
      await dispatch(emptyPurchaseReturn());
      localStorage.removeItem('daybook');
      localStorage.removeItem('accountId');
   }, [dispatch, initialLineItem, lastPurchaseReturnDaybook?.daybookId, user?.id]);

   const getInvoiceData = useCallback(async () => {
      if (id) await dispatch(getPurchaseReturnInvoice(id));
   }, [dispatch, id]);

   const getData = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         // await dispatch(
         //    getAllDaybooks({
         //       type: 12,
         //       companyId: Number(user?.loginhistory?.companyId),
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getAccount({
         //       compId: user?.loginhistory?.companyId,
         //       accountTypes: ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].join(','),
         //       ...(shouldSendCompanyIdAccount && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         await dispatch(getUsers());
         // await dispatch(
         //    getItem({
         //       companyId: user.loginhistory.companyId,
         //       sortBy: 'name',
         //       sortOrder: 'asc',
         //       ...(shouldSendCompanyIdItem && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         // await dispatch(
         //    getPaymentDaybook({
         //       isPayment: true,
         //       companyId: Number(user?.loginhistory?.companyId),
         //       ...(shouldSendCompanyIdDaybook && { companyIds: user?.loginhistory?.companyId }),
         //    }),
         // );
         await dispatch(
            getWarehouse({ ...(shouldSendCompanyIdWarehouse && { companyIds: user?.loginhistory?.companyId }) }),
         );
         await dispatch(getFinancialYears({ companyId: user?.loginhistory?.companyId }));
      }
      await dispatch(getMainAndSubHsn());
      await dispatch(getGLGroupsAllDropdown());
      setIsPageLoading(false);
   }, [dispatch, user]);

   useEffect(() => {
      if (user && !user?.packageData?.[0]?.purchase_return) {
         window.history.back();
      }
   }, [user]);

   useEffect(() => {
      getData();
   }, [getData]);

   useEffect(() => {
      if (row.header.daybookId || lastPurchaseReturnDaybook?.daybookId) {
         const daybookId = row.header.daybookId ? row.header.daybookId : lastPurchaseReturnDaybook?.daybookId;
         dispatch(
            getBillTerm({
               daybookId: daybookId,
               ...(shouldSendCompanyidBillTerm && { companyIds: user?.loginhistory?.companyId }),
            }),
         );
      }
   }, [dispatch, lastPurchaseReturnDaybook?.daybookId, row.header.daybookId]);

   useEffect(() => {
      if (!id) {
         const selectedAccount = accountData.find((ac) => ac.id === row.header.accountId);
         const selectedDaybook = daybookData.find((db) => db.id === row.header.daybookId);

         if (selectedAccount && selectedAccount?.defaultDueDays) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: selectedAccount?.defaultDueDays,
                  dueAt: moment().add(Number(selectedAccount?.defaultDueDays), 'days').format('YYYY-MM-DD'),
               },
            }));
         } else if (selectedDaybook && selectedDaybook?.dueDays) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: selectedDaybook?.dueDays,
                  dueAt: moment().add(Number(selectedDaybook?.dueDays), 'days').format('YYYY-MM-DD'),
               },
            }));
         } else {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  dueDays: 0,
                  dueAt: moment().add(Number(0), 'days').format('YYYY-MM-DD'),
               },
            }));
         }
      }
   }, [row.header.daybookId, row.header.accountId]);

   // edit data by id
   useEffect(() => {
      getInvoiceData();
   }, [getInvoiceData]);

   // set new create account id
   useEffect(() => {
      if (accountId) {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               accountId: accountId,
            },
         }));
      }
   }, [accountId]);

   // set create account data
   useEffect(() => {
      handleEditValues();
   }, [handleEditValues]);

   // set last sale daybook
   useEffect(() => {
      // if (!id) {
      if (lastPurchaseReturnDaybook && lastPurchaseReturnDaybook.docno) {
         const currentDocNo = String(lastPurchaseReturnDaybook.docno ?? 0);
         const nextDocNo =
            salesInvoice?.daybookId === lastPurchaseReturnDaybook?.daybookId
               ? salesInvoice?.docno
               : ((parseInt(currentDocNo) + 1).toString() ?? '1');
         // const nextDocNo = (parseInt(currentDocNo) + 1).toString() ?? '1';
         const selectedDaybookForPrefix = daybookData?.find(
            (db) => db.id === Number(lastPurchaseReturnDaybook.daybookId)
         );
         if (selectedDaybookForPrefix) {
            setOriginalPrefix(selectedDaybookForPrefix?.prefix || '');
            setOriginalPostFix(selectedDaybookForPrefix?.suffix || '');
         }
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: lastPurchaseReturnDaybook.daybookId,
               docno: nextDocNo,
               partyNo: id ? salesInvoice?.partyNo : company?.setting?.partynoequaltodocno ? nextDocNo : '',
               prefix: selectedDaybookForPrefix?.prefix || prev.header.prefix || '',
               postFix: selectedDaybookForPrefix?.suffix || prev.header.postFix || '',
            },
            lineItem: prev.lineItem?.map((item) => {
               return {
                  ...item,
                  typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
               };
            }),
         }));
      } else {
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               docno: '1',
               partyNo: company?.setting?.partynoequaltodocno ? '1' : '',
            },
            lineItem: prev.lineItem?.map((item) => {
               return {
                  ...item,
                  typeOfSupply: SupplyTypes?.find((item) => item.id === daybook?.typeOfSupply)?.id || 1,
               };
            }),
         }));
      }
      // }
   }, [company?.setting?.partynoequaltodocno, daybook?.typeOfSupply, id, lastPurchaseReturnDaybook, daybookData?.length]);

   useEffect(() => {
      if (daybookId) {
         setDaybookId(daybookId);
         setRow((prev) => ({
            ...prev,
            header: {
               ...prev.header,
               daybookId: Number(daybookId),
            },
         }));
      }
   }, [daybookId, setDaybookId]);

   useEffect(() => {
      if (billTermData && billTermData?.length > 0 && !id) {
         const initialBillTerms = billTermData?.map((term) => {
            return {
               billTermId: term.id,
               percentage: term.percentValue || 0,
               amount: 0,
            };
         });
         setBillTerms(initialBillTerms);
      }
   }, [billTermData, id]);

   useEffect(() => {
      if (row.header.accountId) {
         const state = account?.accountaddress?.find((a) => a.name === 'billing')?.stateId;
         const companyState = company?.stateid;
         setIsSameState(state?.toString() === companyState?.toString());
      }
   }, [account?.accountaddress, company?.stateid, row.header.accountId]);

   useEffect(() => {
      const stocks = row.lineItem
         ?.filter((x) => x.isDeleted === false)
         ?.flatMap((li) => {
            if (!li.itemId) return [];
            return li.stock;
         });

      setRow((prevRow) => ({
         ...prevRow,
         lineItem: prevRow.lineItem?.map((item) => {
            if (!item.itemId) return { ...item, stock: [] };
            return item;
         }),
      }));

      setSelectedStocks(getUniqueByStock(stocks));
   }, [JSON.stringify(row.lineItem)]);

   useEffect(() => {
      const selectedStocks = row?.lineItem
         ?.filter((stock, idx) => stock.isDeleted === false && idx !== currentLineItemIdx)
         .flatMap((li) => li.stock.map((i) => i.serialNo?.trim()));
      setStockList(getUniqueByStock(stocks.filter((s) => !selectedStocks.includes(s.serialNo))));
   }, [stocks]);

   useEffect(() => {
      if (!id) {
         if (row.header.daybookId) {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }
      }
   }, [id, row.header.daybookId]);

   useEffect(() => {
      prepareRowRefs(row.lineItem?.length);
   }, [row.lineItem?.length]);

   useEffect(() => {
      prepareBillTermRowRefs(billTermData?.length);
   }, [billTermData?.length]);

   // useEffect(() => {
   //    const timer = setTimeout(() => {
   //       setIsPageLoading(false);
   //    }, 5000);

   //    return () => clearTimeout(timer);
   // }, [row.header.daybookId]);

   // useEffect(() => {
   //    if (!id) {
   //       if (row.header.daybookId) {
   //          if (daybookRef.current) {
   //             daybookRef.current.focus();
   //          }
   //       }
   //    }
   // }, [id, row.header.daybookId, isPageLoading]);

   useEffect(() => {
      if (!id && !isPageLoading) {
         const timer = setTimeout(() => {
            if (daybookRef.current) {
               daybookRef.current.focus();
            }
         }, 100);
         return () => clearTimeout(timer);
      }
   }, [id, isPageLoading]);

   useEffect(() => {
      if (!id) {
         setRow((prev) => ({
            ...prev,
            header: { ...prev.header, representativeId: user?.id },
         }));
      }
   }, [id, user?.id]);

   const filteredDaybooks = daybookData.filter((item) => item.type === 6);
   const daybookbalance = daybookData.find((item) => item.id === row?.header?.daybookId)?.bal ?? null;

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            const activeElement = document.activeElement;

            if (activeElement !== docNoRef.current) {
               // Focus docnoRef if not already focused
               docNoRef.current?.focus();
            } else {
               // If already focused, go back
               window.history.back();
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const selectdaybookdata = daybookData.find((daybook) => daybook.id === row.header.daybookId);
   const herderview =
      selectdaybookdata?.warehouseInId === 1
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 1
               ? true
               : false
            : false;
   const lineitemview =
      selectdaybookdata?.warehouseInId === 2
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 2
               ? true
               : false
            : false;
   const lineDetailview =
      selectdaybookdata?.warehouseInId === 3
         ? true
         : selectdaybookdata?.warehouseInId === null
            ? companyData?.setting?.warehouseInPurchase === 3
               ? true
               : false
            : false;

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (herderview === true) {
            setRow((prev) => ({
               ...prev,
               header: {
                  ...prev.header,
                  warehouseId: selectdaybookdata?.wareHouseId
                     ? selectdaybookdata?.wareHouseId
                     : companyData?.setting?.warehouseId
                        ? companyData?.setting?.warehouseId
                        : 1,
               },
            }));
         }
      }
   }, [row.header.daybookId]);

   useEffect(() => {
      if (companyData?.setting?.warehouseWishStock === true) {
         if (lineitemview === true || lineDetailview === true) {
            setRow((prev) => ({
               ...prev,
               lineItem: Array.isArray(prev.lineItem)
                  ? prev.lineItem.map((item) => ({
                     ...item,
                     warehouseId:
                        item.warehouseId === null // checks for null or undefined
                           ? selectdaybookdata?.wareHouseId
                              ? selectdaybookdata?.wareHouseId
                              : companyData?.setting?.warehouseId
                                 ? companyData?.setting?.warehouseId
                                 : 1
                           : item.warehouseId,
                  }))
                  : [],
            }));
         }
      }
   }, [row.header.daybookId, row.lineItem?.length]);

   return (
      <>
         <Card
            flexDirection="column"
            w="100%"
            px="0px"
            overflowX={{ sm: 'scroll', lg: 'hidden' }}
            mt="40px"
            position="relative"
            minH={'90vh'}
            maxH={'90vh'}
            overflowY={'scroll'}>
            <CardHeader>
               <Heading size="md">
                  <Flex gap={3} justifyContent="space-between" alignItems="center">
                     <Box>
                        <Flex alignItems="center" gap={2}>
                           <img
                              src={back}
                              alt="Go Back"
                              width="15px"
                              onClick={() => {
                                 handleReset();
                                 window.history.back();
                              }} // Navigate to the previous page
                              style={{ cursor: 'pointer' }} // Ensure it's clickable
                           ></img>
                           {id ? 'Update' : 'Add'} Purchase Return
                           {typeof daybookbalance === 'number' && daybookbalance !== 0 && (
                              <Text
                                 as="span"
                                 fontSize="sm"
                                 fontWeight="normal"
                                 ml={2}
                                 color={daybookbalance < 0 ? 'green.500' : 'red.500'}>
                                 (Balance:
                                 <>
                                    ₹{(Math.abs(daybookbalance)?.toFixed(2) || '0.00').split('.')[0]}.
                                    <Text as="span" fontSize="11px" verticalAlign="baseline">
                                       {(Math.abs(daybookbalance)?.toFixed(2) || '0.00').split('.')[1]}
                                    </Text>
                                 </>
                                 )
                              </Text>
                           )}
                        </Flex>
                     </Box>
                     {id && salesInvoice ? (
                        <Box>
                           <Flex gap={2} alignItems="center">
                              <Heading as="h3" size="lg">
                                 {salesInvoice?.pendingamt ? `₹${salesInvoice?.pendingamt}` : ''}
                              </Heading>
                              <Badge
                                 border="1px solid"
                                 bg="transparent"
                                 borderColor={pendingPayment?.borderColor}
                                 color={pendingPayment?.badgeColor}
                                 borderRadius="md"
                                 w="100%"
                                 textAlign="center"
                                 textTransform="capitalize">
                                 {salesInvoice?.pendingstatus?.replace(/\s*\[.*?\]/, '')?.trim()}
                              </Badge>
                              <Icon
                                 as={FaCircleInfo}
                                 boxSize={4}
                                 // ml={3}
                                 color="green.600"
                                 onClick={handleAdjustedDocs}
                                 cursor="pointer"
                              />
                           </Flex>
                        </Box>
                     ) : null}
                  </Flex>
               </Heading>
            </CardHeader>
            <CardBody>
               <Box position="relative">
                  {isPageLoading ? (
                     <Flex w="full" justifyContent="center" alignItems="center">
                        <Image src={loaderAnimation} width={150} height={150} objectFit="cover" />
                     </Flex>
                  ) : (
                     <>
                        <form>
                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'daybookId',
                                    'Daybook',
                                    daybookData.filter((item) => item.type === 12),
                                    {
                                       errorName: 'header.daybookId',
                                       value: row.header.daybookId,
                                       onChange: (value) => handleDaybook('daybookId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: daybookRef,
                                       nextRef: docNoRef,
                                       showCustomNoOptions: true,
                                       openfrom: 'salesdaybook',
                                       type: 12,
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Daybook',
                                 )}
                              </GridItem>
                              <GridItem colSpan={1}>
                                 <Flex gap={2}>
                                    <Box flex={1}>
                                       <InputField
                                          ref={prefixRef}
                                          type="text"
                                          name="prefix"
                                          label="Prefix"
                                          value={row.header.prefix}
                                          onChange={(e) => {
                                             const selectedDaybookObj = daybookData?.find(
                                                (db) => db.id === Number(row.header.daybookId)
                                             );
                                             const separator = selectedDaybookObj?.separator || '';
                                             const rawValue = e.target.value;
                                             let sanitizedValue = rawValue.replace(/[^A-Za-z0-9]/g, '');
                                             if (separator) {
                                                const escapedSep = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                                const withoutSep = rawValue.replace(new RegExp(escapedSep, 'g'), '');
                                                const cleanValue = withoutSep.replace(/[^A-Za-z0-9]/g, '');
                                                sanitizedValue = `${cleanValue}${separator}`;
                                             }

                                             const sanitizedEvent = {
                                                ...e,
                                                target: { ...e.target, value: sanitizedValue, name: e.target.name },
                                             };
                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                          onKeyDown={(e) => handleKeyDown(e, docNoRef, daybookRef)}
                                       />
                                    </Box>
                                    <Box flex={1}>
                                       <InputField
                                          ref={docNoRef}
                                          type="text"
                                          name="docno"
                                          label="Doc No"
                                          value={row.header.docno}
                                          onChange={(e) => {
                                             const sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
                                             const sanitizedEvent = {
                                                ...e,
                                                target: {
                                                   ...e.target,
                                                   value: sanitizedValue,
                                                   name: e.target.name,
                                                },
                                             };

                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                          onKeyDown={async (e) => {
                                             if (e.key === 'PageUp') {
                                                e.preventDefault();
                                                if (!id) {
                                                   if (lastPurchaseReturnDaybook?.id)
                                                      navigate(`/admin/sales/invoice/edit/${lastPurchaseReturnDaybook?.id}`);
                                                } else {
                                                   const res = await dispatch(
                                                      getPrevAndNext({
                                                         id: id,
                                                         daybookId: row.header.daybookId,
                                                         companyId: user?.loginhistory?.companyId,
                                                      }),
                                                   );
                                                   if (res.prev) navigate(`/admin/sales/invoice/edit/${res.prev}`);
                                                   else navigate(`/admin/sales/invoice/add`);
                                                }
                                                return;
                                             }
                                             if (e.key === 'PageDown') {
                                                e.preventDefault();
                                                if (!id) {
                                                   if (lastPurchaseReturnDaybook?.id)
                                                      navigate(`/admin/sales/invoice/edit/${lastPurchaseReturnDaybook?.id}`);
                                                } else {
                                                   const res = await dispatch(
                                                      getPrevAndNext({
                                                         id: id,
                                                         daybookId: row.header.daybookId,
                                                         companyId: user?.loginhistory?.companyId,
                                                      }),
                                                   );
                                                   if (res.next) navigate(`/admin/sales/invoice/edit/${res.next}`);
                                                   else navigate(`/admin/sales/invoice/add`);
                                                }
                                                return;
                                             }
                                             handleKeyDown(e, transactionAtRef, daybookRef);
                                          }}
                                          autoFocus={id > 0 ? true : false}
                                       />
                                    </Box>
                                    <Box flex={1}>
                                       <InputField
                                          ref={suffixRef}
                                          type="text"
                                          name="postFix"
                                          label="Suffix"
                                          value={row.header.postFix}
                                          onChange={(e) => {
                                             const selectedDaybookObj = daybookData?.find(
                                                (db) => db.id === Number(row.header.daybookId)
                                             );
                                             const separator = selectedDaybookObj?.separator || '';
                                             const rawValue = e.target.value;
                                             let sanitizedValue = rawValue.replace(/[^A-Za-z0-9]/g, '');
                                             if (separator) {
                                                const escapedSep = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                                                const withoutSep = rawValue.replace(new RegExp(escapedSep, 'g'), '');
                                                const cleanValue = withoutSep.replace(/[^A-Za-z0-9]/g, '');
                                                sanitizedValue = `${separator}${cleanValue}`;
                                             }
                                             const sanitizedEvent = {
                                                ...e,
                                                target: { ...e.target, value: sanitizedValue, name: e.target.name },
                                             };
                                             handleInputChange('header', sanitizedEvent);
                                          }}
                                          onKeyDown={(e) => handleKeyDown(e, transactionAtRef, docNoRef)}
                                       />
                                    </Box>
                                 </Flex>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 {account &&
                                    (account.mobile ||
                                       account.email ||
                                       account.panNo ||
                                       account.addressJson?.length > 0 ||
                                       account.gstRegNo ||
                                       account.brokername ||
                                       account.amt) ? (
                                    <Box
                                       border="1.5px solid"
                                       borderColor="gray.200"
                                       borderRadius="15px"
                                       padding="20px"
                                       marginLeft="40px"
                                       width="80%">
                                       {/* First Row: Mobile, Email, PAN */}
                                       <Flex gap={6} mb={4} flexWrap="wrap">
                                          {account.mobile && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={phone} alt="Phone Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.mobile}</Text>
                                             </Flex>
                                          )}

                                          {account.email && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={Email} alt="Email Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.email}</Text>
                                             </Flex>
                                          )}

                                          {account.panNo && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={panno} alt="PAN Icon" boxSize="22px" mr={2} />
                                                <Text fontSize="sm">{account.panNo}</Text>
                                             </Flex>
                                          )}
                                       </Flex>

                                       {/* Second Row: Address */}
                                       {account.addressJson?.length > 0 && (
                                          <Flex alignItems="start" mb={4}>
                                             <Image src={map} alt="Address Icon" boxSize="20px" mr={2} mt={1} />
                                             <Box>
                                                {account.addressJson.map((address, index) => (
                                                   <Text key={index} fontSize="sm">
                                                      {address.address1}
                                                   </Text>
                                                ))}
                                             </Box>
                                          </Flex>
                                       )}

                                       {/* Third Row: GST, Broker, Balance */}
                                       <Flex gap={6} flexWrap="wrap">
                                          {account.gstRegNo && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={gstno} alt="GST Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.gstRegNo}</Text>
                                             </Flex>
                                          )}

                                          {account.brokername && (
                                             <Flex alignItems="center" minW="fit-content">
                                                <Image src={Brokername} alt="Broker Icon" boxSize="20px" mr={2} />
                                                <Text fontSize="sm">{account.brokername}</Text>
                                             </Flex>
                                          )}

                                          {account.amt ? (
                                             <GridItem display="flex" alignItems="center">
                                                <Image
                                                   src={Balance}
                                                   alt="editicon"
                                                   boxSize="20px"
                                                   mr={2}
                                                   title="Balance Icon"
                                                />
                                                {account.amt}
                                             </GridItem>
                                          ) : null}
                                       </Flex>
                                    </Box>
                                 ) : null}
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={transactionAtRef}
                                    type="date"
                                    name="transactionAt"
                                    label="Transaction Date"
                                    value={row.header.transactionAt}
                                    onChange={(e) => {
                                       let value = e.target.value; // yyyy-mm-dd

                                       const parts = value.split('-');
                                       if (parts[0]?.length > 4) {
                                          parts[0] = parts[0].slice(0, 4);
                                          value = parts.join('-');
                                       }
                                       handleInputChange('header', {
                                          target: {
                                             name: e.target.name,
                                             value,
                                          },
                                       });
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, accountRef, docNoRef)}
                                 />
                              </GridItem>
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={accountRef}
                                    name="accountId"
                                    options={accountData}
                                    label="Account"
                                    value={row.header.accountId}
                                    errors={errors}
                                    errorName="header.accountId"
                                    isClearable
                                    isSearchable
                                    onChange={(value) => {
                                       handleAccount('accountId', value);
                                    }}
                                    onKeyDown={(e) => handleKeyDown(e, partyBillNoRef, transactionAtRef)}
                                    showCustomNoOptions={true}
                                    openfrom="purchaseReturn"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={partyBillNoRef}
                                    type="text"
                                    name="partyNo"
                                    errorName="header.partyNo"
                                    label="Party Bill No"
                                    value={row.header.partyNo}
                                    onChange={(e) => handleInputChange('header', e)}
                                    errors={errors}
                                    onKeyDown={(e) => handleKeyDown(e, partyDateRef, accountRef)}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={partyDateRef}
                                    type="date"
                                    name="partyDate"
                                    label="Party Bill Date"
                                    value={row.header.partyDate}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={(e) => handleKeyDown(e, originalBillNoRef, partyBillNoRef)}
                                 />
                              </GridItem>

                              <GridItem w="100%" colSpan={2}></GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={originalBillNoRef}
                                    type="text"
                                    name="originalBillNo"
                                    label="Original Bill No"
                                    value={row.header.originalBillNo}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={(e) => handleKeyDown(e, originalDateRef, partyDateRef)}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 <InputField
                                    ref={originalDateRef}
                                    type="date"
                                    name="originalBillDate"
                                    label="Original Bill Date"
                                    value={row.header.originalBillDate}
                                    onChange={(e) => handleInputChange('header', e)}
                                    onKeyDown={(e) => handleKeyDown(e, brokerRef, originalBillNoRef)}
                                 />
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'brokerId',
                                    'Broker',
                                    accountData,
                                    {
                                       errorName: 'header.brokerId',
                                       value: row.header.brokerId,
                                       onChange: (value) => handleAccount('brokerId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: brokerRef,
                                       nextRef: supplierRef,
                                       preRef: originalDateRef,
                                       onKeyDown: (e) => {
                                          if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                             e.preventDefault();
                                             supplierRef?.current?.focus();
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'account',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Broker',
                                 )}
                              </GridItem>

                              <GridItem w="100%">
                                 {renderDynamicDropdown(
                                    'representativeId',
                                    'Saleman',
                                    salesManList,
                                    {
                                       errorName: 'header.representativeId',
                                       value: row.header.representativeId,
                                       onChange: (value) => handleAccount('representativeId', value),
                                       focusBorderColor: 'blue.500',
                                       _focus: {
                                          boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)',
                                       },
                                       ref: supplierRef,
                                       nextRef: itemRefs?.current[0],
                                       preRef: brokerRef,
                                       // onKeyDown: (e) => {
                                       //    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
                                       //       e.preventDefault();
                                       //       if (
                                       //          companyData?.setting?.warehouseWishStock === true &&
                                       //          herderview === true
                                       //       ) {
                                       //          wareHouseRef?.current?.focus();
                                       //       } else {
                                       //          itemRefs?.current[0]?.focus();
                                       //       }
                                       //    }
                                       // },
                                       onKeyDown: (e) => {
                                          e.preventDefault();
                                          if (daybook?.isAskIncomeExpenses) {
                                             handleKeyDown(e, incomeRef, brokerRef);
                                             return;
                                          }
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             handleKeyDown(e, wareHouseRef, brokerRef);
                                             return;
                                          }
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             if (
                                                companyData?.setting?.warehouseWishStock === true &&
                                                (lineitemview === true || lineDetailview === true)
                                             ) {
                                                warehouseRef?.current[0]?.focus();
                                             } else {
                                                itemRefs?.current[0]?.focus();
                                             }
                                          }
                                       },
                                       showCustomNoOptions: true,
                                       openfrom: 'Saleman',
                                    },
                                    errors,
                                    textColor,
                                    false,
                                    'Select Saleman',
                                 )}
                              </GridItem>

                              {daybook?.isAskIncomeExpenses ? (
                                 <GridItem w="100%">
                                    <AccountSelect
                                       ref={incomeRef}
                                       name="incomeId"
                                       options={incomeAccounts}
                                       label="Expenses Account"
                                       value={row.header.incomeId}
                                       errors={errors}
                                       errorName="header.incomeId"
                                       isClearable
                                       isSearchable
                                       onChange={(value) => {
                                          handleAccount('incomeId', value);
                                       }}
                                       onKeyDown={(e) => {
                                          if (
                                             companyData?.setting?.warehouseWishStock === true &&
                                             herderview === true
                                          ) {
                                             e.preventDefault();
                                             handleKeyDown(e, wareHouseRef, supplierRef);
                                          } else {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                itemRefs?.current[0]?.focus();
                                             }
                                          }
                                       }}
                                       showCustomNoOptions={true}
                                       openfrom="salesdaybook"
                                       glGroup={targetGlGroup}
                                    />
                                 </GridItem>
                              ) : null}
                              <GridItem w="100%">
                                 <AccountSelect
                                    ref={incomeRef}
                                    name="incomeId"
                                    options={incomeAccounts}
                                    label="Income"
                                    value={row.header.incomeId}
                                    errors={errors}
                                    errorName="header.incomeId"
                                    isClearable
                                    isSearchable
                                    onChange={(value) => {
                                       handleAccount('incomeId', value);
                                    }}
                                    onKeyDown={(e) => {
                                       if (companyData?.setting?.warehouseWishStock === true && herderview === true) {
                                          e.preventDefault();
                                          handleKeyDown(e, wareHouseRef, supplierRef);
                                       } else {
                                          if (e.key === 'Enter' || e.key === 'Tab') {
                                             e.preventDefault();
                                             itemRefs?.current[0]?.focus();
                                          }
                                       }
                                    }}
                                    showCustomNoOptions={true}
                                    openfrom="salesdaybook"
                                    glGroup={targetGlGroup}
                                 />
                              </GridItem>

                              {companyData?.setting?.warehouseWishStock === true && herderview === true && (
                                 <GridItem className="seperator-width">
                                    {/* change */}
                                    {renderDynamicDropdown(
                                       'warehouseId',
                                       'Ware House',
                                       warehouseList,
                                       {
                                          value: row.header.warehouseId,
                                          onChange: (value) => handleAccount('warehouseId', value),
                                          showCustomNoOptions: true,
                                          openfrom: 'wareHouse',
                                          ref: wareHouseRef,
                                          onKeyDown: (e) => {
                                             if (e.key === 'Enter' || e.key === 'Tab') {
                                                e.preventDefault();
                                                if (e.shiftKey) {
                                                   if (daybook?.isAskIncomeExpenses) {
                                                      incomeRef?.current?.focus();
                                                   } else {
                                                      supplierRef?.current?.focus();
                                                   }
                                                } else {
                                                   itemRefs?.current[0]?.focus();
                                                }
                                             }
                                          },
                                       },
                                       errors,
                                       textColor,
                                       false,
                                       'Select Ware House',
                                    )}
                                 </GridItem>
                              )}
                           </Grid>

                           <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                              <GridItem w="100%" colSpan={4}>
                                 <Box my={3}>
                                    <LineItem
                                       addLineItem={addLineItem}
                                       lineItems={row.lineItem}
                                       itemData={itemData}
                                       textColor={textColor}
                                       lastDaybook={daybook}
                                       removeLineItem={removeLineItem}
                                       handleOnChange={handleOnChange}
                                       companyData={companyList}
                                       totals={totals}
                                       handleStockModalOnClick={handleStockModalOnClick}
                                       errors={errors}
                                       refs={refs}
                                       prerefs={
                                          companyData?.setting?.warehouseWishStock === true && herderview === true
                                             ? wareHouseRef
                                             : daybook?.isAskIncomeExpenses
                                                ? incomeRef
                                                : supplierRef
                                       }
                                       setCurrentLineItemIdx={setCurrentLineItemIdx}
                                       warehouseList={warehouseList}
                                       lineitemview={lineitemview === true ? lineitemview : lineDetailview}
                                       selectcompany={companyData}
                                       billTermData={billTermData}
                                    />
                                 </Box>
                              </GridItem>
                           </Grid>

                           <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(4, 1fr)" gap={3}>
                              <GridItem w="100%" colSpan={2}>
                                 <Grid templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDaysRef}
                                          type="number"
                                          name="dueDays"
                                          label="Due Days"
                                          value={row.header.dueDays}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => {
                                             if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                e.preventDefault();
                                             }
                                             if (e.key === 'Tab' && e.shiftKey) {
                                                if (refs?.amountRefs?.current) {
                                                   const lastIndex = refs.amountRefs.current?.length - 1;
                                                   refs.amountRefs.current[lastIndex]?.focus();
                                                }
                                             }
                                             handleKeyDown(e, dueDateRef);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                       />
                                    </GridItem>

                                    <GridItem w="100%">
                                       <InputField
                                          ref={dueDateRef}
                                          type="date"
                                          name="dueAt"
                                          label="Due Date"
                                          value={row.header.dueAt}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, notesRef, dueDaysRef)}
                                       />
                                    </GridItem>

                                    {showTds && (
                                       <>
                                          <GridItem w="100%">
                                             <InputField
                                                ref={tdsRateRef}
                                                type="number"
                                                name="tdsRate"
                                                label="TDS Rate (%)"
                                                min={0}
                                                max={100}
                                                value={row.header.tdsRate}
                                                onChange={(e) => {
                                                   const val = parseFloat(e.target.value);
                                                   if (e.target.value === '' || e.target.value === null) {
                                                      handleInputChange('header', e);
                                                      return;
                                                   }
                                                   if (val < 0 || val > 100) return;
                                                   handleInputChange('header', e);
                                                }}
                                                onWheel={(e) => e.target.blur()}
                                             />
                                          </GridItem>

                                          <GridItem w="100%">
                                             <InputField
                                                ref={tdsAmountRef}
                                                type="number"
                                                name="tdsAmount"
                                                label="TDS Amount"
                                                value={row.header.tdsAmount}
                                                onChange={(e) => handleInputChange('header', e)}
                                                onWheel={(e) => e.target.blur()}
                                             />
                                          </GridItem>
                                       </>
                                    )}

                                    {id && salesInvoice && salesInvoice.tdsRate > 0 && (
                                       <GridItem w="100%" colSpan={2}>
                                          <Box
                                             display="flex"
                                             alignItems="center"
                                             gap={2}
                                             px={3}
                                             py={2}
                                             borderRadius="lg"
                                             // bgGradient="linear(to-r, blue.50, blue.100)"
                                             bgGradient="linear(to-r, to-r, to-r)"
                                             border="1px solid"
                                             borderColor="blue.300"
                                             _dark={{
                                                bgGradient: 'linear(to-r, blue.900, blue.800)',
                                                borderColor: 'blue.600',
                                             }}
                                          >
                                             <Icon as={FaCircleInfo} color="blue.500" boxSize={4} flexShrink={0} />

                                             <Text fontSize="sm" color="gray.700" _dark={{ color: 'gray.300' }}>
                                                TDS Rate:
                                                <Text as="span" ml={1} mr={3} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   {Number(salesInvoice.tdsRate || 0).toFixed(2)}%,
                                                </Text>

                                                TDS Amt:
                                                <Text as="span" ml={1} mr={3} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   ₹{Number(salesInvoice.tdsAmount || 0).toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })},
                                                </Text>

                                                TDS Calc. ON:
                                                <Text as="span" ml={1} mr={3} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   ₹{Number(
                                                      salesInvoice.tdsRate > 0
                                                         ? salesInvoice.tdsAmount * 100 / salesInvoice.tdsRate
                                                         : 0
                                                   ).toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })},
                                                </Text>

                                                To Pay:
                                                <Text as="span" ml={1} fontWeight="bold" color="blue.600" _dark={{ color: 'blue.300' }}>
                                                   ₹{Number(
                                                      (salesInvoice.netAmount || 0) - (salesInvoice.tdsAmount || 0)
                                                   ).toLocaleString('en-IN', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                   })},
                                                </Text>
                                             </Text>
                                          </Box>
                                       </GridItem>
                                    )}

                                    <GridItem w="100%" colSpan={2}>
                                       <TextareaField
                                          ref={notesRef}
                                          name="notes"
                                          label="Notes"
                                          value={row.header.notes}
                                          onChange={(e) => handleInputChange('header', e)}
                                          onKeyDown={(e) => handleKeyDown(e, submitRef, dueDateRef)}
                                       />
                                    </GridItem>

                                    <GridItem w="100%" colSpan={2}>
                                       {selectedStocks?.length > 0 ? (
                                          <TableContainer
                                             border="1px"
                                             borderColor="gray.200"
                                             borderRadius={5}
                                             maxH="300px"
                                             overflowY="auto">
                                             <Table variant="simple" size="sm">
                                                <Thead bg="gray.200">
                                                   <Tr>
                                                      <Th>Item</Th>
                                                      <Th>Series No</Th>
                                                      <Th>Warehouse</Th>
                                                      {/* <Th isNumeric>Stock</Th> */}
                                                      <Th>Action</Th>
                                                   </Tr>
                                                </Thead>
                                                <Tbody>
                                                   {selectedStocks &&
                                                      removeDuplicates(selectedStocks, 'serialNo')?.map(
                                                         (item, index) => {
                                                            return (
                                                               <Tr key={index}>
                                                                  <Td>{item.itemName}</Td>
                                                                  <Td>
                                                                     {item.serialNo}
                                                                     <Icon
                                                                        as={FaHistory}
                                                                        boxSize={4}
                                                                        ml={3}
                                                                        color="green.600"
                                                                        onClick={() => handleSerialHistory(item)}
                                                                        cursor="pointer"
                                                                     />
                                                                  </Td>
                                                                  <Td>{item.warehouseName}</Td>
                                                                  <Td>
                                                                     <IconButton
                                                                        colorScheme="red"
                                                                        size="sm"
                                                                        onClick={() => removeStock(item)}
                                                                        icon={<FaTrash />}
                                                                     />
                                                                  </Td>
                                                               </Tr>
                                                            );
                                                         },
                                                      )}
                                                </Tbody>
                                             </Table>
                                          </TableContainer>
                                       ) : null}
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                              <GridItem w="100%" colSpan={2} rowSpan={2}>
                                 <Grid templateRows="repeat(1, 1fr)" templateColumns="repeat(2, 1fr)" gap={3}>
                                    <GridItem colSpan={2}>
                                       <BillTerm
                                          textColor={textColor}
                                          billTermData={row.header.daybookId > 0 ? billTermData : []}
                                          billTerms={row.header.daybookId > 0 ? billTerms : []}
                                          netAmount={totals.netAmount}
                                          handleBillTermChange={handleBillTermChange}
                                          refs={refs}
                                       />
                                    </GridItem>
                                    <GridItem w="100%" colSpan={2}>
                                       <TaxableAmount
                                          totals={totals}
                                          isSameState={isSameState}
                                          finalNetAmount={finalNetAmount}
                                          daybook={daybook}
                                          company={company}
                                       />
                                    </GridItem>
                                 </Grid>
                              </GridItem>
                           </Grid>
                        </form>
                        <CardFooter justifyContent="flex-end" gap={3}>
                           <Button
                              ref={submitRef}
                              colorScheme="green"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="full"
                              _active={{ bg: '#06b' }}
                              onClick={() => handleSubmit()}
                              isLoading={isLoading}
                              loadingText={id ? 'Updating...' : 'Saving...'}
                              disabled={isLoading}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'Tab' && e.shiftKey) {
                                    e.preventDefault();
                                    // Focus the last paymentRefs element
                                    // const lastIndex = paymentRefs.current.length - 1;
                                    notesRef.current?.focus();
                                 } else if (e.key === 'ArrowRight') {
                                    e.preventDefault();
                                    closeRef.current?.focus();
                                 }
                              }}>
                              {id ? 'Update' : 'Save'}
                           </Button>
                           <Button
                              ref={closeRef}
                              colorScheme="red"
                              onClick={() => {
                                 dispatch(emptyPurchaseReturn());
                                 handleReset();
                                 navigate('/admin/purchase/return');
                              }}
                              _focus={{ outlineColor: 'blue.500 ' }}
                              onKeyDown={(e) => {
                                 if (e.key === 'ArrowLeft') {
                                    e.preventDefault();
                                    submitRef.current?.focus();
                                 }
                              }}>
                              Cancel
                           </Button>
                        </CardFooter>
                     </>
                  )}
               </Box>
            </CardBody>
         </Card>

         {/* Serial number modal */}
         <SerialNumberModal
            isOpen={isOpenModal}
            onClose={onCloseModal}
            stockList={stockList}
            selectedStocks={selectedStocks}
            handleSelectStock={handleSelectStock}
            onCloseComplete={() => {
               setTimeout(() => {
                  if (daybook?.isAllowGstRate && company?.setting?.applyGST && daybook?.applyGst) {
                     gstRateRefs.current[currentLineItemIdx]?.focus();
                  } else {
                     rateRefs.current[currentLineItemIdx]?.focus();
                  }
               }, 0);
            }}
            currentItemId={row.lineItem[currentLineItemIdx]?.itemId}
            currentIdx={currentLineItemIdx}
            lineItem={row.lineItem}
         />

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Delete Line Item"
         />

         {/* Print Format Moal  */}
         <PrintFormat
            isOpen={isOpenPrintFormatModal}
            onClose={onClosePrintFormatModal}
            daybook={daybook}
            functionName="Purchase Returns"
            redirect="/admin/purchase/return"
         />
         <Modal isOpen={isOpenSerialhistory} onClose={onCloseSerialhistory} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Serial History({data[0]?.serial_no})</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {data?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              <Th>Transaction at</Th>
                              <Th>Transaction Type</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Item Rate</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {data.map((data, index) => (
                              <Tr key={index}>
                                 <Td>{data.doc_no}</Td>
                                 <Td>{new Date(data.transaction_at).toLocaleDateString('en-GB')}</Td>
                                 <Td>{data.transaction_type}</Td>
                                 <Td>{data.account_name}</Td>
                                 <Td>{data.daybook_name}</Td>
                                 <Td>{data.item_rate}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No transaction history found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>
         <Modal isOpen={isOpenAdjustedDocs} onClose={onCloseAdjustedDocs} size="6xl">
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Adjusted Docs</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  {adjustedDocs?.length > 0 ? (
                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr>
                              <Th>Doc No</Th>
                              {/* <Th>Transaction at</Th> */}
                              {/* <Th>Transaction Type</Th> */}
                              <Th>Txn Date</Th>
                              <Th>Account Name</Th>
                              <Th>Daybook Name</Th>
                              <Th>Amount</Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {adjustedDocs?.map((txn, index) => (
                              <Tr key={index}>
                                 <Td>{txn.adj_docno}</Td>
                                 {/* <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td> */}
                                 {/* <Td>{txn.transaction_type}</Td> */}
                                 <Td>{new Date(txn.adj_txnDate).toLocaleDateString('en-GB')}</Td>
                                 <Td>{txn.adj_accountname}</Td>
                                 <Td>
                                    {selectedDaybookData?.length > 0
                                       ? txn.adj_daybookname === selectedDaybookData[0].name
                                          ? txn.daybookname
                                          : txn.adj_daybookname
                                       : txn.adj_daybookname}
                                 </Td>
                                 <Td>{txn.amount}</Td>
                              </Tr>
                           ))}
                        </Tbody>
                     </Table>
                  ) : (
                     <Text color="gray.500">No Adjusted Docs Data found.</Text>
                  )}
               </ModalBody>
            </ModalContent>
         </Modal>

         {/* Serial Number Block Modal */}
         <SerialNoBlockModal
            isOpen={isOpenSerialBlockModal}
            onClose={() => {
               onCloseSerialBlockModal();
               // user pressed cancel — still navigate away
               postBlockAction && postBlockAction();
               setPostBlockAction(null);
               setPendingBlockSerials([]);
            }}
            serialList={pendingBlockSerials}
            accountId={row.header.accountId}
            onSuccess={() => {
               onCloseSerialBlockModal();
               postBlockAction && postBlockAction();
               setPostBlockAction(null);
               setPendingBlockSerials([]);
            }}
         />
      </>
   );
};

export default PurchaseReturnInvoiceForm;
